/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PublicImport } from './routes/_public'
import { Route as AuthImport } from './routes/_auth'
import { Route as PublicTestDataImport } from './routes/_public/test-data'
import { Route as PublicSamlErrorImport } from './routes/_public/saml-error'
import { Route as PublicMethodNotSupportedImport } from './routes/_public/method-not-supported'
import { Route as PublicLogoutImport } from './routes/_public/logout'
import { Route as PublicLoginImport } from './routes/_public/login'
import { Route as PublicConnectForBusinessImport } from './routes/_public/connect-for-business'
import { Route as PublicAuthenticationErrorImport } from './routes/_public/authentication-error'
import { Route as PublicAccessDeniedImport } from './routes/_public/access-denied'
import { Route as PublicLayoutImport } from './routes/_public/_layout'
import { Route as AuthEnterpriseImport } from './routes/_auth/enterprise'
import { Route as AuthOnlyHeaderImport } from './routes/_auth/_only-header'
import { Route as AuthLayoutImport } from './routes/_auth/_layout'
import { Route as redirectsSettingsImport } from './routes/(redirects)/settings'
import { Route as redirectsFleetImport } from './routes/(redirects)/fleet'
import { Route as redirectsCheckoutImport } from './routes/(redirects)/checkout'
import { Route as AuthEnterpriseIndexImport } from './routes/_auth/enterprise/index'
import { Route as AuthLayoutIndexImport } from './routes/_auth/_layout/index'
import { Route as PublicLandingPageDeviceSetupImport } from './routes/_public/landing-page.device-setup'
import { Route as PublicDownloadsMobileAppImport } from './routes/_public/downloads.mobile-app'
import { Route as AuthPairAppImport } from './routes/_auth/pair.app'
import { Route as AuthEnterpriseLinkImport } from './routes/_auth/enterprise/link'
import { Route as AuthEnterpriseEnrollImport } from './routes/_auth/enterprise/enroll'
import { Route as AuthEnterpriseWithOrgImport } from './routes/_auth/enterprise/_with-org'
import { Route as AuthOnlyHeaderVerifyNewEmailImport } from './routes/_auth/_only-header/verify-new-email'
import { Route as AuthOnlyHeaderStoreImport } from './routes/_auth/_only-header/store'
import { Route as AuthLayoutSubscriptionsImport } from './routes/_auth/_layout/subscriptions'
import { Route as AuthLayoutMyfilesImport } from './routes/_auth/_layout/myfiles'
import { Route as AuthLayoutIntegrationsImport } from './routes/_auth/_layout/integrations'
import { Route as AuthLayoutDeviceImport } from './routes/_auth/_layout/device'
import { Route as AuthLayoutDataAccessConsentImport } from './routes/_auth/_layout/data-access-consent'
import { Route as AuthLayoutAccountImport } from './routes/_auth/_layout/account'
import { Route as AuthnoLayoutVerifiedImport } from './routes/_auth/(no-layout)/verified'
import { Route as redirectsFleetMembersImport } from './routes/(redirects)/fleet.members'
import { Route as AuthEnterpriseEnrollIndexImport } from './routes/_auth/enterprise/enroll/index'
import { Route as AuthOnlyHeaderStoreIndexImport } from './routes/_auth/_only-header/store/index'
import { Route as AuthLayoutSubscriptionsIndexImport } from './routes/_auth/_layout/subscriptions/index'
import { Route as AuthLayoutPairIndexImport } from './routes/_auth/_layout/pair/index'
import { Route as AuthLayoutIntegrationsIndexImport } from './routes/_auth/_layout/integrations.index'
import { Route as AuthLayoutDeviceIndexImport } from './routes/_auth/_layout/device/index'
import { Route as AuthLayoutAccountIndexImport } from './routes/_auth/_layout/account/index'
import { Route as AuthEnterpriseEnrollVerifySamlImport } from './routes/_auth/enterprise/enroll/verify-saml'
import { Route as AuthEnterpriseEnrollVerifyDomainImport } from './routes/_auth/enterprise/enroll/verify-domain'
import { Route as AuthEnterpriseEnrollSetupSamlImport } from './routes/_auth/enterprise/enroll/setup-saml'
import { Route as AuthEnterpriseEnrollSetupImport } from './routes/_auth/enterprise/enroll/setup'
import { Route as AuthEnterpriseEnrollCreateOrganizationImport } from './routes/_auth/enterprise/enroll/create-organization'
import { Route as AuthEnterpriseEnrollConfirmSetupImport } from './routes/_auth/enterprise/enroll/confirm-setup'
import { Route as AuthEnterpriseWithOrgLayoutImport } from './routes/_auth/enterprise/_with-org/_layout'
import { Route as AuthOnlyHeaderStoreMethodsOfferImport } from './routes/_auth/_only-header/store/methods-offer'
import { Route as AuthOnlyHeaderStoreDmOfferImport } from './routes/_auth/_only-header/store/dm-offer'
import { Route as AuthOnlyHeaderStoreConnectOfferImport } from './routes/_auth/_only-header/store/connect-offer'
import { Route as AuthOnlyHeaderStoreConfirmationImport } from './routes/_auth/_only-header/store/confirmation'
import { Route as AuthOnlyHeaderStoreCheckoutReturnImport } from './routes/_auth/_only-header/store/checkout-return'
import { Route as AuthOnlyHeaderStoreCheckoutImport } from './routes/_auth/_only-header/store/checkout'
import { Route as AuthLayoutSubscriptionsPlanImport } from './routes/_auth/_layout/subscriptions/plan'
import { Route as AuthLayoutSubscriptionsPaymentImport } from './routes/_auth/_layout/subscriptions/payment'
import { Route as AuthLayoutSubscriptionsMembersImport } from './routes/_auth/_layout/subscriptions/members'
import { Route as AuthLayoutInvitationSeatImport } from './routes/_auth/_layout/invitation/seat'
import { Route as AuthLayoutIntegrationsCallbackImport } from './routes/_auth/_layout/integrations.callback'
import { Route as AuthLayoutDeviceRemarkableImport } from './routes/_auth/_layout/device/remarkable'
import { Route as AuthLayoutDeviceMobileImport } from './routes/_auth/_layout/device/mobile'
import { Route as AuthLayoutDeviceDesktopImport } from './routes/_auth/_layout/device/desktop'
import { Route as AuthLayoutDeviceBrowserImport } from './routes/_auth/_layout/device/browser'
import { Route as AuthLayoutAccountDeleteImport } from './routes/_auth/_layout/account/delete'
import { Route as AuthnoLayoutAccountDeleteImport } from './routes/_auth/(no-layout)/account/delete'
import { Route as AuthEnterpriseWithOrgOffboardingIndexImport } from './routes/_auth/enterprise/_with-org/offboarding.index'
import { Route as AuthLayoutDeviceAppsIndexImport } from './routes/_auth/_layout/device/apps/index'
import { Route as AuthLayoutAccountMigrateIndexImport } from './routes/_auth/_layout/account/migrate.index'
import { Route as AuthLayoutAccountDeleteIndexImport } from './routes/_auth/_layout/account/delete.index'
import { Route as PublicLayoutAccountMigrateSamlImport } from './routes/_public/_layout/account.migrate.saml'
import { Route as AuthEnterpriseWithOrgLayoutSettingsImport } from './routes/_auth/enterprise/_with-org/_layout.settings'
import { Route as AuthEnterpriseWithOrgLayoutPoliciesImport } from './routes/_auth/enterprise/_with-org/_layout.policies'
import { Route as AuthEnterpriseWithOrgLayoutPlanImport } from './routes/_auth/enterprise/_with-org/_layout.plan'
import { Route as AuthEnterpriseWithOrgLayoutMembersImport } from './routes/_auth/enterprise/_with-org/_layout.members'
import { Route as AuthEnterpriseWithOrgLayoutDomainsImport } from './routes/_auth/enterprise/_with-org/_layout.domains'
import { Route as AuthEnterpriseWithOrgLayoutDevicesImport } from './routes/_auth/enterprise/_with-org/_layout.devices'
import { Route as AuthEnterpriseWithOrgLayoutBillingImport } from './routes/_auth/enterprise/_with-org/_layout.billing'
import { Route as AuthOnlyHeaderStoreMethodsOfferSetupCompleteImport } from './routes/_auth/_only-header/store/methods-offer.setup-complete'
import { Route as AuthOnlyHeaderStoreMethodsOfferDownloadAppsImport } from './routes/_auth/_only-header/store/methods-offer.download-apps'
import { Route as AuthOnlyHeaderStoreMethodsOfferConfirmationImport } from './routes/_auth/_only-header/store/methods-offer.confirmation'
import { Route as AuthOnlyHeaderStoreMethodsOfferAllowedImport } from './routes/_auth/_only-header/store/methods-offer._allowed'
import { Route as AuthOnlyHeaderStoreDmOfferSetupCompleteImport } from './routes/_auth/_only-header/store/dm-offer.setup-complete'
import { Route as AuthOnlyHeaderStoreDmOfferConfirmationImport } from './routes/_auth/_only-header/store/dm-offer.confirmation'
import { Route as AuthOnlyHeaderStoreDmOfferAllowedImport } from './routes/_auth/_only-header/store/dm-offer._allowed'
import { Route as AuthOnlyHeaderStoreConnectConfirmationImport } from './routes/_auth/_only-header/store/connect.confirmation'
import { Route as AuthOnlyHeaderStoreConnectAllowedImport } from './routes/_auth/_only-header/store/connect._allowed'
import { Route as AuthOnlyHeaderStoreConnectOfferSetupCompleteImport } from './routes/_auth/_only-header/store/connect-offer.setup-complete'
import { Route as AuthOnlyHeaderStoreConnectOfferDownloadAppsImport } from './routes/_auth/_only-header/store/connect-offer.download-apps'
import { Route as AuthOnlyHeaderStoreConnectOfferConfirmationImport } from './routes/_auth/_only-header/store/connect-offer.confirmation'
import { Route as AuthOnlyHeaderStoreConnectOfferAllowedImport } from './routes/_auth/_only-header/store/connect-offer._allowed'
import { Route as AuthLayoutDeviceRemarkableConnectImport } from './routes/_auth/_layout/device/remarkable_.connect'
import { Route as AuthLayoutDeviceMobileConnectImport } from './routes/_auth/_layout/device/mobile_.connect'
import { Route as AuthLayoutDeviceDesktopConnectImport } from './routes/_auth/_layout/device/desktop_.connect'
import { Route as AuthLayoutDeviceBrowserConnectImport } from './routes/_auth/_layout/device/browser_.connect'
import { Route as AuthLayoutDeviceAppsConnectImport } from './routes/_auth/_layout/device/apps/connect'
import { Route as AuthLayoutAccountMigrateSuccessImport } from './routes/_auth/_layout/account/migrate.success'
import { Route as AuthLayoutAccountDeleteLandingImport } from './routes/_auth/_layout/account/delete.landing'
import { Route as AuthLayoutAccountDeleteConfirmationImport } from './routes/_auth/_layout/account/delete.confirmation'
import { Route as AuthOnlyHeaderStoreMethodsOfferAllowedIndexImport } from './routes/_auth/_only-header/store/methods-offer._allowed.index'
import { Route as AuthOnlyHeaderStoreDmOfferAllowedIndexImport } from './routes/_auth/_only-header/store/dm-offer._allowed.index'
import { Route as AuthOnlyHeaderStoreConnectAllowedIndexImport } from './routes/_auth/_only-header/store/connect._allowed.index'
import { Route as AuthOnlyHeaderStoreConnectOfferAllowedIndexImport } from './routes/_auth/_only-header/store/connect-offer._allowed.index'
import { Route as AuthOnlyHeaderStoreMethodsOfferAllowedCheckoutImport } from './routes/_auth/_only-header/store/methods-offer._allowed.checkout'
import { Route as AuthOnlyHeaderStoreDmOfferAllowedCheckoutImport } from './routes/_auth/_only-header/store/dm-offer._allowed.checkout'
import { Route as AuthOnlyHeaderStoreConnectAllowedCheckoutImport } from './routes/_auth/_only-header/store/connect._allowed.checkout'
import { Route as AuthOnlyHeaderStoreConnectOfferAllowedCheckoutImport } from './routes/_auth/_only-header/store/connect-offer._allowed.checkout'
import { Route as AuthnoLayoutAccountDeleteLandingAppImport } from './routes/_auth/(no-layout)/account/delete/landing.app'
import { Route as AuthnoLayoutAccountDeleteConfirmationAppImport } from './routes/_auth/(no-layout)/account/delete/confirmation.app'

// Create Virtual Routes

const AuthOnlyHeaderStoreConnectImport = createFileRoute(
  '/_auth/_only-header/store/connect',
)()
const AuthLayoutMyfilesSplatLazyImport = createFileRoute(
  '/_auth/_layout/myfiles/$',
)()

// Create/Update Routes

const PublicRoute = PublicImport.update({
  id: '/_public',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const PublicTestDataRoute = PublicTestDataImport.update({
  id: '/test-data',
  path: '/test-data',
  getParentRoute: () => PublicRoute,
} as any)

const PublicSamlErrorRoute = PublicSamlErrorImport.update({
  id: '/saml-error',
  path: '/saml-error',
  getParentRoute: () => PublicRoute,
} as any)

const PublicMethodNotSupportedRoute = PublicMethodNotSupportedImport.update({
  id: '/method-not-supported',
  path: '/method-not-supported',
  getParentRoute: () => PublicRoute,
} as any)

const PublicLogoutRoute = PublicLogoutImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => PublicRoute,
} as any)

const PublicLoginRoute = PublicLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)

const PublicConnectForBusinessRoute = PublicConnectForBusinessImport.update({
  id: '/connect-for-business',
  path: '/connect-for-business',
  getParentRoute: () => PublicRoute,
} as any)

const PublicAuthenticationErrorRoute = PublicAuthenticationErrorImport.update({
  id: '/authentication-error',
  path: '/authentication-error',
  getParentRoute: () => PublicRoute,
} as any)

const PublicAccessDeniedRoute = PublicAccessDeniedImport.update({
  id: '/access-denied',
  path: '/access-denied',
  getParentRoute: () => PublicRoute,
} as any)

const PublicLayoutRoute = PublicLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => PublicRoute,
} as any)

const AuthEnterpriseRoute = AuthEnterpriseImport.update({
  id: '/enterprise',
  path: '/enterprise',
  getParentRoute: () => AuthRoute,
} as any)

const AuthOnlyHeaderRoute = AuthOnlyHeaderImport.update({
  id: '/_only-header',
  getParentRoute: () => AuthRoute,
} as any)

const AuthLayoutRoute = AuthLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AuthRoute,
} as any)

const redirectsSettingsRoute = redirectsSettingsImport.update({
  id: '/(redirects)/settings',
  path: '/settings',
  getParentRoute: () => rootRoute,
} as any)

const redirectsFleetRoute = redirectsFleetImport.update({
  id: '/(redirects)/fleet',
  path: '/fleet',
  getParentRoute: () => rootRoute,
} as any)

const redirectsCheckoutRoute = redirectsCheckoutImport.update({
  id: '/(redirects)/checkout',
  path: '/checkout',
  getParentRoute: () => rootRoute,
} as any)

const AuthEnterpriseIndexRoute = AuthEnterpriseIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthEnterpriseRoute,
} as any)

const AuthLayoutIndexRoute = AuthLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthLayoutRoute,
} as any)

const PublicLandingPageDeviceSetupRoute =
  PublicLandingPageDeviceSetupImport.update({
    id: '/landing-page/device-setup',
    path: '/landing-page/device-setup',
    getParentRoute: () => PublicRoute,
  } as any)

const PublicDownloadsMobileAppRoute = PublicDownloadsMobileAppImport.update({
  id: '/downloads/mobile-app',
  path: '/downloads/mobile-app',
  getParentRoute: () => PublicRoute,
} as any)

const AuthPairAppRoute = AuthPairAppImport.update({
  id: '/pair/app',
  path: '/pair/app',
  getParentRoute: () => AuthRoute,
} as any)

const AuthEnterpriseLinkRoute = AuthEnterpriseLinkImport.update({
  id: '/link',
  path: '/link',
  getParentRoute: () => AuthEnterpriseRoute,
} as any)

const AuthEnterpriseEnrollRoute = AuthEnterpriseEnrollImport.update({
  id: '/enroll',
  path: '/enroll',
  getParentRoute: () => AuthEnterpriseRoute,
} as any)

const AuthEnterpriseWithOrgRoute = AuthEnterpriseWithOrgImport.update({
  id: '/_with-org',
  getParentRoute: () => AuthEnterpriseRoute,
} as any)

const AuthOnlyHeaderVerifyNewEmailRoute =
  AuthOnlyHeaderVerifyNewEmailImport.update({
    id: '/verify-new-email',
    path: '/verify-new-email',
    getParentRoute: () => AuthOnlyHeaderRoute,
  } as any)

const AuthOnlyHeaderStoreRoute = AuthOnlyHeaderStoreImport.update({
  id: '/store',
  path: '/store',
  getParentRoute: () => AuthOnlyHeaderRoute,
} as any)

const AuthLayoutSubscriptionsRoute = AuthLayoutSubscriptionsImport.update({
  id: '/subscriptions',
  path: '/subscriptions',
  getParentRoute: () => AuthLayoutRoute,
} as any)

const AuthLayoutMyfilesRoute = AuthLayoutMyfilesImport.update({
  id: '/myfiles',
  path: '/myfiles',
  getParentRoute: () => AuthLayoutRoute,
} as any)

const AuthLayoutIntegrationsRoute = AuthLayoutIntegrationsImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AuthLayoutRoute,
} as any)

const AuthLayoutDeviceRoute = AuthLayoutDeviceImport.update({
  id: '/device',
  path: '/device',
  getParentRoute: () => AuthLayoutRoute,
} as any)

const AuthLayoutDataAccessConsentRoute =
  AuthLayoutDataAccessConsentImport.update({
    id: '/data-access-consent',
    path: '/data-access-consent',
    getParentRoute: () => AuthLayoutRoute,
  } as any)

const AuthLayoutAccountRoute = AuthLayoutAccountImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthLayoutRoute,
} as any)

const AuthnoLayoutVerifiedRoute = AuthnoLayoutVerifiedImport.update({
  id: '/(no-layout)/verified',
  path: '/verified',
  getParentRoute: () => AuthRoute,
} as any)

const redirectsFleetMembersRoute = redirectsFleetMembersImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => redirectsFleetRoute,
} as any)

const AuthOnlyHeaderStoreConnectRoute = AuthOnlyHeaderStoreConnectImport.update(
  {
    id: '/connect',
    path: '/connect',
    getParentRoute: () => AuthOnlyHeaderStoreRoute,
  } as any,
)

const AuthEnterpriseEnrollIndexRoute = AuthEnterpriseEnrollIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthEnterpriseEnrollRoute,
} as any)

const AuthOnlyHeaderStoreIndexRoute = AuthOnlyHeaderStoreIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOnlyHeaderStoreRoute,
} as any)

const AuthLayoutSubscriptionsIndexRoute =
  AuthLayoutSubscriptionsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthLayoutSubscriptionsRoute,
  } as any)

const AuthLayoutPairIndexRoute = AuthLayoutPairIndexImport.update({
  id: '/pair/',
  path: '/pair/',
  getParentRoute: () => AuthLayoutRoute,
} as any)

const AuthLayoutIntegrationsIndexRoute =
  AuthLayoutIntegrationsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthLayoutIntegrationsRoute,
  } as any)

const AuthLayoutDeviceIndexRoute = AuthLayoutDeviceIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthLayoutDeviceRoute,
} as any)

const AuthLayoutAccountIndexRoute = AuthLayoutAccountIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthLayoutAccountRoute,
} as any)

const AuthLayoutMyfilesSplatLazyRoute = AuthLayoutMyfilesSplatLazyImport.update(
  {
    id: '/$',
    path: '/$',
    getParentRoute: () => AuthLayoutMyfilesRoute,
  } as any,
).lazy(() =>
  import('./routes/_auth/_layout/myfiles.$.lazy').then((d) => d.Route),
)

const AuthEnterpriseEnrollVerifySamlRoute =
  AuthEnterpriseEnrollVerifySamlImport.update({
    id: '/verify-saml',
    path: '/verify-saml',
    getParentRoute: () => AuthEnterpriseEnrollRoute,
  } as any)

const AuthEnterpriseEnrollVerifyDomainRoute =
  AuthEnterpriseEnrollVerifyDomainImport.update({
    id: '/verify-domain',
    path: '/verify-domain',
    getParentRoute: () => AuthEnterpriseEnrollRoute,
  } as any)

const AuthEnterpriseEnrollSetupSamlRoute =
  AuthEnterpriseEnrollSetupSamlImport.update({
    id: '/setup-saml',
    path: '/setup-saml',
    getParentRoute: () => AuthEnterpriseEnrollRoute,
  } as any)

const AuthEnterpriseEnrollSetupRoute = AuthEnterpriseEnrollSetupImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AuthEnterpriseEnrollRoute,
} as any)

const AuthEnterpriseEnrollCreateOrganizationRoute =
  AuthEnterpriseEnrollCreateOrganizationImport.update({
    id: '/create-organization',
    path: '/create-organization',
    getParentRoute: () => AuthEnterpriseEnrollRoute,
  } as any)

const AuthEnterpriseEnrollConfirmSetupRoute =
  AuthEnterpriseEnrollConfirmSetupImport.update({
    id: '/confirm-setup',
    path: '/confirm-setup',
    getParentRoute: () => AuthEnterpriseEnrollRoute,
  } as any)

const AuthEnterpriseWithOrgLayoutRoute =
  AuthEnterpriseWithOrgLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthEnterpriseWithOrgRoute,
  } as any)

const AuthOnlyHeaderStoreMethodsOfferRoute =
  AuthOnlyHeaderStoreMethodsOfferImport.update({
    id: '/methods-offer',
    path: '/methods-offer',
    getParentRoute: () => AuthOnlyHeaderStoreRoute,
  } as any)

const AuthOnlyHeaderStoreDmOfferRoute = AuthOnlyHeaderStoreDmOfferImport.update(
  {
    id: '/dm-offer',
    path: '/dm-offer',
    getParentRoute: () => AuthOnlyHeaderStoreRoute,
  } as any,
)

const AuthOnlyHeaderStoreConnectOfferRoute =
  AuthOnlyHeaderStoreConnectOfferImport.update({
    id: '/connect-offer',
    path: '/connect-offer',
    getParentRoute: () => AuthOnlyHeaderStoreRoute,
  } as any)

const AuthOnlyHeaderStoreConfirmationRoute =
  AuthOnlyHeaderStoreConfirmationImport.update({
    id: '/confirmation',
    path: '/confirmation',
    getParentRoute: () => AuthOnlyHeaderStoreRoute,
  } as any)

const AuthOnlyHeaderStoreCheckoutReturnRoute =
  AuthOnlyHeaderStoreCheckoutReturnImport.update({
    id: '/checkout-return',
    path: '/checkout-return',
    getParentRoute: () => AuthOnlyHeaderStoreRoute,
  } as any)

const AuthOnlyHeaderStoreCheckoutRoute =
  AuthOnlyHeaderStoreCheckoutImport.update({
    id: '/checkout',
    path: '/checkout',
    getParentRoute: () => AuthOnlyHeaderStoreRoute,
  } as any)

const AuthLayoutSubscriptionsPlanRoute =
  AuthLayoutSubscriptionsPlanImport.update({
    id: '/plan',
    path: '/plan',
    getParentRoute: () => AuthLayoutSubscriptionsRoute,
  } as any)

const AuthLayoutSubscriptionsPaymentRoute =
  AuthLayoutSubscriptionsPaymentImport.update({
    id: '/payment',
    path: '/payment',
    getParentRoute: () => AuthLayoutSubscriptionsRoute,
  } as any)

const AuthLayoutSubscriptionsMembersRoute =
  AuthLayoutSubscriptionsMembersImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthLayoutSubscriptionsRoute,
  } as any)

const AuthLayoutInvitationSeatRoute = AuthLayoutInvitationSeatImport.update({
  id: '/invitation/seat',
  path: '/invitation/seat',
  getParentRoute: () => AuthLayoutRoute,
} as any)

const AuthLayoutIntegrationsCallbackRoute =
  AuthLayoutIntegrationsCallbackImport.update({
    id: '/callback',
    path: '/callback',
    getParentRoute: () => AuthLayoutIntegrationsRoute,
  } as any)

const AuthLayoutDeviceRemarkableRoute = AuthLayoutDeviceRemarkableImport.update(
  {
    id: '/remarkable',
    path: '/remarkable',
    getParentRoute: () => AuthLayoutDeviceRoute,
  } as any,
)

const AuthLayoutDeviceMobileRoute = AuthLayoutDeviceMobileImport.update({
  id: '/mobile',
  path: '/mobile',
  getParentRoute: () => AuthLayoutDeviceRoute,
} as any)

const AuthLayoutDeviceDesktopRoute = AuthLayoutDeviceDesktopImport.update({
  id: '/desktop',
  path: '/desktop',
  getParentRoute: () => AuthLayoutDeviceRoute,
} as any)

const AuthLayoutDeviceBrowserRoute = AuthLayoutDeviceBrowserImport.update({
  id: '/browser',
  path: '/browser',
  getParentRoute: () => AuthLayoutDeviceRoute,
} as any)

const AuthLayoutAccountDeleteRoute = AuthLayoutAccountDeleteImport.update({
  id: '/delete',
  path: '/delete',
  getParentRoute: () => AuthLayoutAccountRoute,
} as any)

const AuthnoLayoutAccountDeleteRoute = AuthnoLayoutAccountDeleteImport.update({
  id: '/(no-layout)/account/delete',
  path: '/account/delete',
  getParentRoute: () => AuthRoute,
} as any)

const AuthEnterpriseWithOrgOffboardingIndexRoute =
  AuthEnterpriseWithOrgOffboardingIndexImport.update({
    id: '/offboarding/',
    path: '/offboarding/',
    getParentRoute: () => AuthEnterpriseWithOrgRoute,
  } as any)

const AuthLayoutDeviceAppsIndexRoute = AuthLayoutDeviceAppsIndexImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => AuthLayoutDeviceRoute,
} as any)

const AuthLayoutAccountMigrateIndexRoute =
  AuthLayoutAccountMigrateIndexImport.update({
    id: '/migrate/',
    path: '/migrate/',
    getParentRoute: () => AuthLayoutAccountRoute,
  } as any)

const AuthLayoutAccountDeleteIndexRoute =
  AuthLayoutAccountDeleteIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthLayoutAccountDeleteRoute,
  } as any)

const PublicLayoutAccountMigrateSamlRoute =
  PublicLayoutAccountMigrateSamlImport.update({
    id: '/account/migrate/saml',
    path: '/account/migrate/saml',
    getParentRoute: () => PublicLayoutRoute,
  } as any)

const AuthEnterpriseWithOrgLayoutSettingsRoute =
  AuthEnterpriseWithOrgLayoutSettingsImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthEnterpriseWithOrgLayoutRoute,
  } as any)

const AuthEnterpriseWithOrgLayoutPoliciesRoute =
  AuthEnterpriseWithOrgLayoutPoliciesImport.update({
    id: '/policies',
    path: '/policies',
    getParentRoute: () => AuthEnterpriseWithOrgLayoutRoute,
  } as any)

const AuthEnterpriseWithOrgLayoutPlanRoute =
  AuthEnterpriseWithOrgLayoutPlanImport.update({
    id: '/plan',
    path: '/plan',
    getParentRoute: () => AuthEnterpriseWithOrgLayoutRoute,
  } as any)

const AuthEnterpriseWithOrgLayoutMembersRoute =
  AuthEnterpriseWithOrgLayoutMembersImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthEnterpriseWithOrgLayoutRoute,
  } as any)

const AuthEnterpriseWithOrgLayoutDomainsRoute =
  AuthEnterpriseWithOrgLayoutDomainsImport.update({
    id: '/domains',
    path: '/domains',
    getParentRoute: () => AuthEnterpriseWithOrgLayoutRoute,
  } as any)

const AuthEnterpriseWithOrgLayoutDevicesRoute =
  AuthEnterpriseWithOrgLayoutDevicesImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => AuthEnterpriseWithOrgLayoutRoute,
  } as any)

const AuthEnterpriseWithOrgLayoutBillingRoute =
  AuthEnterpriseWithOrgLayoutBillingImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthEnterpriseWithOrgLayoutRoute,
  } as any)

const AuthOnlyHeaderStoreMethodsOfferSetupCompleteRoute =
  AuthOnlyHeaderStoreMethodsOfferSetupCompleteImport.update({
    id: '/setup-complete',
    path: '/setup-complete',
    getParentRoute: () => AuthOnlyHeaderStoreMethodsOfferRoute,
  } as any)

const AuthOnlyHeaderStoreMethodsOfferDownloadAppsRoute =
  AuthOnlyHeaderStoreMethodsOfferDownloadAppsImport.update({
    id: '/download-apps',
    path: '/download-apps',
    getParentRoute: () => AuthOnlyHeaderStoreMethodsOfferRoute,
  } as any)

const AuthOnlyHeaderStoreMethodsOfferConfirmationRoute =
  AuthOnlyHeaderStoreMethodsOfferConfirmationImport.update({
    id: '/confirmation',
    path: '/confirmation',
    getParentRoute: () => AuthOnlyHeaderStoreMethodsOfferRoute,
  } as any)

const AuthOnlyHeaderStoreMethodsOfferAllowedRoute =
  AuthOnlyHeaderStoreMethodsOfferAllowedImport.update({
    id: '/_allowed',
    getParentRoute: () => AuthOnlyHeaderStoreMethodsOfferRoute,
  } as any)

const AuthOnlyHeaderStoreDmOfferSetupCompleteRoute =
  AuthOnlyHeaderStoreDmOfferSetupCompleteImport.update({
    id: '/setup-complete',
    path: '/setup-complete',
    getParentRoute: () => AuthOnlyHeaderStoreDmOfferRoute,
  } as any)

const AuthOnlyHeaderStoreDmOfferConfirmationRoute =
  AuthOnlyHeaderStoreDmOfferConfirmationImport.update({
    id: '/confirmation',
    path: '/confirmation',
    getParentRoute: () => AuthOnlyHeaderStoreDmOfferRoute,
  } as any)

const AuthOnlyHeaderStoreDmOfferAllowedRoute =
  AuthOnlyHeaderStoreDmOfferAllowedImport.update({
    id: '/_allowed',
    getParentRoute: () => AuthOnlyHeaderStoreDmOfferRoute,
  } as any)

const AuthOnlyHeaderStoreConnectConfirmationRoute =
  AuthOnlyHeaderStoreConnectConfirmationImport.update({
    id: '/confirmation',
    path: '/confirmation',
    getParentRoute: () => AuthOnlyHeaderStoreConnectRoute,
  } as any)

const AuthOnlyHeaderStoreConnectAllowedRoute =
  AuthOnlyHeaderStoreConnectAllowedImport.update({
    id: '/_allowed',
    getParentRoute: () => AuthOnlyHeaderStoreConnectRoute,
  } as any)

const AuthOnlyHeaderStoreConnectOfferSetupCompleteRoute =
  AuthOnlyHeaderStoreConnectOfferSetupCompleteImport.update({
    id: '/setup-complete',
    path: '/setup-complete',
    getParentRoute: () => AuthOnlyHeaderStoreConnectOfferRoute,
  } as any)

const AuthOnlyHeaderStoreConnectOfferDownloadAppsRoute =
  AuthOnlyHeaderStoreConnectOfferDownloadAppsImport.update({
    id: '/download-apps',
    path: '/download-apps',
    getParentRoute: () => AuthOnlyHeaderStoreConnectOfferRoute,
  } as any)

const AuthOnlyHeaderStoreConnectOfferConfirmationRoute =
  AuthOnlyHeaderStoreConnectOfferConfirmationImport.update({
    id: '/confirmation',
    path: '/confirmation',
    getParentRoute: () => AuthOnlyHeaderStoreConnectOfferRoute,
  } as any)

const AuthOnlyHeaderStoreConnectOfferAllowedRoute =
  AuthOnlyHeaderStoreConnectOfferAllowedImport.update({
    id: '/_allowed',
    getParentRoute: () => AuthOnlyHeaderStoreConnectOfferRoute,
  } as any)

const AuthLayoutDeviceRemarkableConnectRoute =
  AuthLayoutDeviceRemarkableConnectImport.update({
    id: '/remarkable_/connect',
    path: '/remarkable/connect',
    getParentRoute: () => AuthLayoutDeviceRoute,
  } as any)

const AuthLayoutDeviceMobileConnectRoute =
  AuthLayoutDeviceMobileConnectImport.update({
    id: '/mobile_/connect',
    path: '/mobile/connect',
    getParentRoute: () => AuthLayoutDeviceRoute,
  } as any)

const AuthLayoutDeviceDesktopConnectRoute =
  AuthLayoutDeviceDesktopConnectImport.update({
    id: '/desktop_/connect',
    path: '/desktop/connect',
    getParentRoute: () => AuthLayoutDeviceRoute,
  } as any)

const AuthLayoutDeviceBrowserConnectRoute =
  AuthLayoutDeviceBrowserConnectImport.update({
    id: '/browser_/connect',
    path: '/browser/connect',
    getParentRoute: () => AuthLayoutDeviceRoute,
  } as any)

const AuthLayoutDeviceAppsConnectRoute =
  AuthLayoutDeviceAppsConnectImport.update({
    id: '/apps/connect',
    path: '/apps/connect',
    getParentRoute: () => AuthLayoutDeviceRoute,
  } as any)

const AuthLayoutAccountMigrateSuccessRoute =
  AuthLayoutAccountMigrateSuccessImport.update({
    id: '/migrate/success',
    path: '/migrate/success',
    getParentRoute: () => AuthLayoutAccountRoute,
  } as any)

const AuthLayoutAccountDeleteLandingRoute =
  AuthLayoutAccountDeleteLandingImport.update({
    id: '/landing',
    path: '/landing',
    getParentRoute: () => AuthLayoutAccountDeleteRoute,
  } as any)

const AuthLayoutAccountDeleteConfirmationRoute =
  AuthLayoutAccountDeleteConfirmationImport.update({
    id: '/confirmation',
    path: '/confirmation',
    getParentRoute: () => AuthLayoutAccountDeleteRoute,
  } as any)

const AuthOnlyHeaderStoreMethodsOfferAllowedIndexRoute =
  AuthOnlyHeaderStoreMethodsOfferAllowedIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOnlyHeaderStoreMethodsOfferAllowedRoute,
  } as any)

const AuthOnlyHeaderStoreDmOfferAllowedIndexRoute =
  AuthOnlyHeaderStoreDmOfferAllowedIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOnlyHeaderStoreDmOfferAllowedRoute,
  } as any)

const AuthOnlyHeaderStoreConnectAllowedIndexRoute =
  AuthOnlyHeaderStoreConnectAllowedIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOnlyHeaderStoreConnectAllowedRoute,
  } as any)

const AuthOnlyHeaderStoreConnectOfferAllowedIndexRoute =
  AuthOnlyHeaderStoreConnectOfferAllowedIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOnlyHeaderStoreConnectOfferAllowedRoute,
  } as any)

const AuthOnlyHeaderStoreMethodsOfferAllowedCheckoutRoute =
  AuthOnlyHeaderStoreMethodsOfferAllowedCheckoutImport.update({
    id: '/checkout',
    path: '/checkout',
    getParentRoute: () => AuthOnlyHeaderStoreMethodsOfferAllowedRoute,
  } as any)

const AuthOnlyHeaderStoreDmOfferAllowedCheckoutRoute =
  AuthOnlyHeaderStoreDmOfferAllowedCheckoutImport.update({
    id: '/checkout',
    path: '/checkout',
    getParentRoute: () => AuthOnlyHeaderStoreDmOfferAllowedRoute,
  } as any)

const AuthOnlyHeaderStoreConnectAllowedCheckoutRoute =
  AuthOnlyHeaderStoreConnectAllowedCheckoutImport.update({
    id: '/checkout',
    path: '/checkout',
    getParentRoute: () => AuthOnlyHeaderStoreConnectAllowedRoute,
  } as any)

const AuthOnlyHeaderStoreConnectOfferAllowedCheckoutRoute =
  AuthOnlyHeaderStoreConnectOfferAllowedCheckoutImport.update({
    id: '/checkout',
    path: '/checkout',
    getParentRoute: () => AuthOnlyHeaderStoreConnectOfferAllowedRoute,
  } as any)

const AuthnoLayoutAccountDeleteLandingAppRoute =
  AuthnoLayoutAccountDeleteLandingAppImport.update({
    id: '/landing/app',
    path: '/landing/app',
    getParentRoute: () => AuthnoLayoutAccountDeleteRoute,
  } as any)

const AuthnoLayoutAccountDeleteConfirmationAppRoute =
  AuthnoLayoutAccountDeleteConfirmationAppImport.update({
    id: '/confirmation/app',
    path: '/confirmation/app',
    getParentRoute: () => AuthnoLayoutAccountDeleteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicImport
      parentRoute: typeof rootRoute
    }
    '/(redirects)/checkout': {
      id: '/(redirects)/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof redirectsCheckoutImport
      parentRoute: typeof rootRoute
    }
    '/(redirects)/fleet': {
      id: '/(redirects)/fleet'
      path: '/fleet'
      fullPath: '/fleet'
      preLoaderRoute: typeof redirectsFleetImport
      parentRoute: typeof rootRoute
    }
    '/(redirects)/settings': {
      id: '/(redirects)/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof redirectsSettingsImport
      parentRoute: typeof rootRoute
    }
    '/_auth/_layout': {
      id: '/_auth/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthLayoutImport
      parentRoute: typeof AuthImport
    }
    '/_auth/_only-header': {
      id: '/_auth/_only-header'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthOnlyHeaderImport
      parentRoute: typeof AuthImport
    }
    '/_auth/enterprise': {
      id: '/_auth/enterprise'
      path: '/enterprise'
      fullPath: '/enterprise'
      preLoaderRoute: typeof AuthEnterpriseImport
      parentRoute: typeof AuthImport
    }
    '/_public/_layout': {
      id: '/_public/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicLayoutImport
      parentRoute: typeof PublicImport
    }
    '/_public/access-denied': {
      id: '/_public/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof PublicAccessDeniedImport
      parentRoute: typeof PublicImport
    }
    '/_public/authentication-error': {
      id: '/_public/authentication-error'
      path: '/authentication-error'
      fullPath: '/authentication-error'
      preLoaderRoute: typeof PublicAuthenticationErrorImport
      parentRoute: typeof PublicImport
    }
    '/_public/connect-for-business': {
      id: '/_public/connect-for-business'
      path: '/connect-for-business'
      fullPath: '/connect-for-business'
      preLoaderRoute: typeof PublicConnectForBusinessImport
      parentRoute: typeof PublicImport
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginImport
      parentRoute: typeof PublicImport
    }
    '/_public/logout': {
      id: '/_public/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof PublicLogoutImport
      parentRoute: typeof PublicImport
    }
    '/_public/method-not-supported': {
      id: '/_public/method-not-supported'
      path: '/method-not-supported'
      fullPath: '/method-not-supported'
      preLoaderRoute: typeof PublicMethodNotSupportedImport
      parentRoute: typeof PublicImport
    }
    '/_public/saml-error': {
      id: '/_public/saml-error'
      path: '/saml-error'
      fullPath: '/saml-error'
      preLoaderRoute: typeof PublicSamlErrorImport
      parentRoute: typeof PublicImport
    }
    '/_public/test-data': {
      id: '/_public/test-data'
      path: '/test-data'
      fullPath: '/test-data'
      preLoaderRoute: typeof PublicTestDataImport
      parentRoute: typeof PublicImport
    }
    '/(redirects)/fleet/members': {
      id: '/(redirects)/fleet/members'
      path: '/members'
      fullPath: '/fleet/members'
      preLoaderRoute: typeof redirectsFleetMembersImport
      parentRoute: typeof redirectsFleetImport
    }
    '/_auth/(no-layout)/verified': {
      id: '/_auth/(no-layout)/verified'
      path: '/verified'
      fullPath: '/verified'
      preLoaderRoute: typeof AuthnoLayoutVerifiedImport
      parentRoute: typeof AuthImport
    }
    '/_auth/_layout/account': {
      id: '/_auth/_layout/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthLayoutAccountImport
      parentRoute: typeof AuthLayoutImport
    }
    '/_auth/_layout/data-access-consent': {
      id: '/_auth/_layout/data-access-consent'
      path: '/data-access-consent'
      fullPath: '/data-access-consent'
      preLoaderRoute: typeof AuthLayoutDataAccessConsentImport
      parentRoute: typeof AuthLayoutImport
    }
    '/_auth/_layout/device': {
      id: '/_auth/_layout/device'
      path: '/device'
      fullPath: '/device'
      preLoaderRoute: typeof AuthLayoutDeviceImport
      parentRoute: typeof AuthLayoutImport
    }
    '/_auth/_layout/integrations': {
      id: '/_auth/_layout/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AuthLayoutIntegrationsImport
      parentRoute: typeof AuthLayoutImport
    }
    '/_auth/_layout/myfiles': {
      id: '/_auth/_layout/myfiles'
      path: '/myfiles'
      fullPath: '/myfiles'
      preLoaderRoute: typeof AuthLayoutMyfilesImport
      parentRoute: typeof AuthLayoutImport
    }
    '/_auth/_layout/subscriptions': {
      id: '/_auth/_layout/subscriptions'
      path: '/subscriptions'
      fullPath: '/subscriptions'
      preLoaderRoute: typeof AuthLayoutSubscriptionsImport
      parentRoute: typeof AuthLayoutImport
    }
    '/_auth/_only-header/store': {
      id: '/_auth/_only-header/store'
      path: '/store'
      fullPath: '/store'
      preLoaderRoute: typeof AuthOnlyHeaderStoreImport
      parentRoute: typeof AuthOnlyHeaderImport
    }
    '/_auth/_only-header/verify-new-email': {
      id: '/_auth/_only-header/verify-new-email'
      path: '/verify-new-email'
      fullPath: '/verify-new-email'
      preLoaderRoute: typeof AuthOnlyHeaderVerifyNewEmailImport
      parentRoute: typeof AuthOnlyHeaderImport
    }
    '/_auth/enterprise/_with-org': {
      id: '/_auth/enterprise/_with-org'
      path: ''
      fullPath: '/enterprise'
      preLoaderRoute: typeof AuthEnterpriseWithOrgImport
      parentRoute: typeof AuthEnterpriseImport
    }
    '/_auth/enterprise/enroll': {
      id: '/_auth/enterprise/enroll'
      path: '/enroll'
      fullPath: '/enterprise/enroll'
      preLoaderRoute: typeof AuthEnterpriseEnrollImport
      parentRoute: typeof AuthEnterpriseImport
    }
    '/_auth/enterprise/link': {
      id: '/_auth/enterprise/link'
      path: '/link'
      fullPath: '/enterprise/link'
      preLoaderRoute: typeof AuthEnterpriseLinkImport
      parentRoute: typeof AuthEnterpriseImport
    }
    '/_auth/pair/app': {
      id: '/_auth/pair/app'
      path: '/pair/app'
      fullPath: '/pair/app'
      preLoaderRoute: typeof AuthPairAppImport
      parentRoute: typeof AuthImport
    }
    '/_public/downloads/mobile-app': {
      id: '/_public/downloads/mobile-app'
      path: '/downloads/mobile-app'
      fullPath: '/downloads/mobile-app'
      preLoaderRoute: typeof PublicDownloadsMobileAppImport
      parentRoute: typeof PublicImport
    }
    '/_public/landing-page/device-setup': {
      id: '/_public/landing-page/device-setup'
      path: '/landing-page/device-setup'
      fullPath: '/landing-page/device-setup'
      preLoaderRoute: typeof PublicLandingPageDeviceSetupImport
      parentRoute: typeof PublicImport
    }
    '/_auth/_layout/': {
      id: '/_auth/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthLayoutIndexImport
      parentRoute: typeof AuthLayoutImport
    }
    '/_auth/enterprise/': {
      id: '/_auth/enterprise/'
      path: '/'
      fullPath: '/enterprise/'
      preLoaderRoute: typeof AuthEnterpriseIndexImport
      parentRoute: typeof AuthEnterpriseImport
    }
    '/_auth/(no-layout)/account/delete': {
      id: '/_auth/(no-layout)/account/delete'
      path: '/account/delete'
      fullPath: '/account/delete'
      preLoaderRoute: typeof AuthnoLayoutAccountDeleteImport
      parentRoute: typeof AuthImport
    }
    '/_auth/_layout/account/delete': {
      id: '/_auth/_layout/account/delete'
      path: '/delete'
      fullPath: '/account/delete'
      preLoaderRoute: typeof AuthLayoutAccountDeleteImport
      parentRoute: typeof AuthLayoutAccountImport
    }
    '/_auth/_layout/device/browser': {
      id: '/_auth/_layout/device/browser'
      path: '/browser'
      fullPath: '/device/browser'
      preLoaderRoute: typeof AuthLayoutDeviceBrowserImport
      parentRoute: typeof AuthLayoutDeviceImport
    }
    '/_auth/_layout/device/desktop': {
      id: '/_auth/_layout/device/desktop'
      path: '/desktop'
      fullPath: '/device/desktop'
      preLoaderRoute: typeof AuthLayoutDeviceDesktopImport
      parentRoute: typeof AuthLayoutDeviceImport
    }
    '/_auth/_layout/device/mobile': {
      id: '/_auth/_layout/device/mobile'
      path: '/mobile'
      fullPath: '/device/mobile'
      preLoaderRoute: typeof AuthLayoutDeviceMobileImport
      parentRoute: typeof AuthLayoutDeviceImport
    }
    '/_auth/_layout/device/remarkable': {
      id: '/_auth/_layout/device/remarkable'
      path: '/remarkable'
      fullPath: '/device/remarkable'
      preLoaderRoute: typeof AuthLayoutDeviceRemarkableImport
      parentRoute: typeof AuthLayoutDeviceImport
    }
    '/_auth/_layout/integrations/callback': {
      id: '/_auth/_layout/integrations/callback'
      path: '/callback'
      fullPath: '/integrations/callback'
      preLoaderRoute: typeof AuthLayoutIntegrationsCallbackImport
      parentRoute: typeof AuthLayoutIntegrationsImport
    }
    '/_auth/_layout/invitation/seat': {
      id: '/_auth/_layout/invitation/seat'
      path: '/invitation/seat'
      fullPath: '/invitation/seat'
      preLoaderRoute: typeof AuthLayoutInvitationSeatImport
      parentRoute: typeof AuthLayoutImport
    }
    '/_auth/_layout/subscriptions/members': {
      id: '/_auth/_layout/subscriptions/members'
      path: '/members'
      fullPath: '/subscriptions/members'
      preLoaderRoute: typeof AuthLayoutSubscriptionsMembersImport
      parentRoute: typeof AuthLayoutSubscriptionsImport
    }
    '/_auth/_layout/subscriptions/payment': {
      id: '/_auth/_layout/subscriptions/payment'
      path: '/payment'
      fullPath: '/subscriptions/payment'
      preLoaderRoute: typeof AuthLayoutSubscriptionsPaymentImport
      parentRoute: typeof AuthLayoutSubscriptionsImport
    }
    '/_auth/_layout/subscriptions/plan': {
      id: '/_auth/_layout/subscriptions/plan'
      path: '/plan'
      fullPath: '/subscriptions/plan'
      preLoaderRoute: typeof AuthLayoutSubscriptionsPlanImport
      parentRoute: typeof AuthLayoutSubscriptionsImport
    }
    '/_auth/_only-header/store/checkout': {
      id: '/_auth/_only-header/store/checkout'
      path: '/checkout'
      fullPath: '/store/checkout'
      preLoaderRoute: typeof AuthOnlyHeaderStoreCheckoutImport
      parentRoute: typeof AuthOnlyHeaderStoreImport
    }
    '/_auth/_only-header/store/checkout-return': {
      id: '/_auth/_only-header/store/checkout-return'
      path: '/checkout-return'
      fullPath: '/store/checkout-return'
      preLoaderRoute: typeof AuthOnlyHeaderStoreCheckoutReturnImport
      parentRoute: typeof AuthOnlyHeaderStoreImport
    }
    '/_auth/_only-header/store/confirmation': {
      id: '/_auth/_only-header/store/confirmation'
      path: '/confirmation'
      fullPath: '/store/confirmation'
      preLoaderRoute: typeof AuthOnlyHeaderStoreConfirmationImport
      parentRoute: typeof AuthOnlyHeaderStoreImport
    }
    '/_auth/_only-header/store/connect-offer': {
      id: '/_auth/_only-header/store/connect-offer'
      path: '/connect-offer'
      fullPath: '/store/connect-offer'
      preLoaderRoute: typeof AuthOnlyHeaderStoreConnectOfferImport
      parentRoute: typeof AuthOnlyHeaderStoreImport
    }
    '/_auth/_only-header/store/dm-offer': {
      id: '/_auth/_only-header/store/dm-offer'
      path: '/dm-offer'
      fullPath: '/store/dm-offer'
      preLoaderRoute: typeof AuthOnlyHeaderStoreDmOfferImport
      parentRoute: typeof AuthOnlyHeaderStoreImport
    }
    '/_auth/_only-header/store/methods-offer': {
      id: '/_auth/_only-header/store/methods-offer'
      path: '/methods-offer'
      fullPath: '/store/methods-offer'
      preLoaderRoute: typeof AuthOnlyHeaderStoreMethodsOfferImport
      parentRoute: typeof AuthOnlyHeaderStoreImport
    }
    '/_auth/enterprise/_with-org/_layout': {
      id: '/_auth/enterprise/_with-org/_layout'
      path: ''
      fullPath: '/enterprise'
      preLoaderRoute: typeof AuthEnterpriseWithOrgLayoutImport
      parentRoute: typeof AuthEnterpriseWithOrgImport
    }
    '/_auth/enterprise/enroll/confirm-setup': {
      id: '/_auth/enterprise/enroll/confirm-setup'
      path: '/confirm-setup'
      fullPath: '/enterprise/enroll/confirm-setup'
      preLoaderRoute: typeof AuthEnterpriseEnrollConfirmSetupImport
      parentRoute: typeof AuthEnterpriseEnrollImport
    }
    '/_auth/enterprise/enroll/create-organization': {
      id: '/_auth/enterprise/enroll/create-organization'
      path: '/create-organization'
      fullPath: '/enterprise/enroll/create-organization'
      preLoaderRoute: typeof AuthEnterpriseEnrollCreateOrganizationImport
      parentRoute: typeof AuthEnterpriseEnrollImport
    }
    '/_auth/enterprise/enroll/setup': {
      id: '/_auth/enterprise/enroll/setup'
      path: '/setup'
      fullPath: '/enterprise/enroll/setup'
      preLoaderRoute: typeof AuthEnterpriseEnrollSetupImport
      parentRoute: typeof AuthEnterpriseEnrollImport
    }
    '/_auth/enterprise/enroll/setup-saml': {
      id: '/_auth/enterprise/enroll/setup-saml'
      path: '/setup-saml'
      fullPath: '/enterprise/enroll/setup-saml'
      preLoaderRoute: typeof AuthEnterpriseEnrollSetupSamlImport
      parentRoute: typeof AuthEnterpriseEnrollImport
    }
    '/_auth/enterprise/enroll/verify-domain': {
      id: '/_auth/enterprise/enroll/verify-domain'
      path: '/verify-domain'
      fullPath: '/enterprise/enroll/verify-domain'
      preLoaderRoute: typeof AuthEnterpriseEnrollVerifyDomainImport
      parentRoute: typeof AuthEnterpriseEnrollImport
    }
    '/_auth/enterprise/enroll/verify-saml': {
      id: '/_auth/enterprise/enroll/verify-saml'
      path: '/verify-saml'
      fullPath: '/enterprise/enroll/verify-saml'
      preLoaderRoute: typeof AuthEnterpriseEnrollVerifySamlImport
      parentRoute: typeof AuthEnterpriseEnrollImport
    }
    '/_auth/_layout/myfiles/$': {
      id: '/_auth/_layout/myfiles/$'
      path: '/$'
      fullPath: '/myfiles/$'
      preLoaderRoute: typeof AuthLayoutMyfilesSplatLazyImport
      parentRoute: typeof AuthLayoutMyfilesImport
    }
    '/_auth/_layout/account/': {
      id: '/_auth/_layout/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AuthLayoutAccountIndexImport
      parentRoute: typeof AuthLayoutAccountImport
    }
    '/_auth/_layout/device/': {
      id: '/_auth/_layout/device/'
      path: '/'
      fullPath: '/device/'
      preLoaderRoute: typeof AuthLayoutDeviceIndexImport
      parentRoute: typeof AuthLayoutDeviceImport
    }
    '/_auth/_layout/integrations/': {
      id: '/_auth/_layout/integrations/'
      path: '/'
      fullPath: '/integrations/'
      preLoaderRoute: typeof AuthLayoutIntegrationsIndexImport
      parentRoute: typeof AuthLayoutIntegrationsImport
    }
    '/_auth/_layout/pair/': {
      id: '/_auth/_layout/pair/'
      path: '/pair'
      fullPath: '/pair'
      preLoaderRoute: typeof AuthLayoutPairIndexImport
      parentRoute: typeof AuthLayoutImport
    }
    '/_auth/_layout/subscriptions/': {
      id: '/_auth/_layout/subscriptions/'
      path: '/'
      fullPath: '/subscriptions/'
      preLoaderRoute: typeof AuthLayoutSubscriptionsIndexImport
      parentRoute: typeof AuthLayoutSubscriptionsImport
    }
    '/_auth/_only-header/store/': {
      id: '/_auth/_only-header/store/'
      path: '/'
      fullPath: '/store/'
      preLoaderRoute: typeof AuthOnlyHeaderStoreIndexImport
      parentRoute: typeof AuthOnlyHeaderStoreImport
    }
    '/_auth/enterprise/enroll/': {
      id: '/_auth/enterprise/enroll/'
      path: '/'
      fullPath: '/enterprise/enroll/'
      preLoaderRoute: typeof AuthEnterpriseEnrollIndexImport
      parentRoute: typeof AuthEnterpriseEnrollImport
    }
    '/_auth/_layout/account/delete/confirmation': {
      id: '/_auth/_layout/account/delete/confirmation'
      path: '/confirmation'
      fullPath: '/account/delete/confirmation'
      preLoaderRoute: typeof AuthLayoutAccountDeleteConfirmationImport
      parentRoute: typeof AuthLayoutAccountDeleteImport
    }
    '/_auth/_layout/account/delete/landing': {
      id: '/_auth/_layout/account/delete/landing'
      path: '/landing'
      fullPath: '/account/delete/landing'
      preLoaderRoute: typeof AuthLayoutAccountDeleteLandingImport
      parentRoute: typeof AuthLayoutAccountDeleteImport
    }
    '/_auth/_layout/account/migrate/success': {
      id: '/_auth/_layout/account/migrate/success'
      path: '/migrate/success'
      fullPath: '/account/migrate/success'
      preLoaderRoute: typeof AuthLayoutAccountMigrateSuccessImport
      parentRoute: typeof AuthLayoutAccountImport
    }
    '/_auth/_layout/device/apps/connect': {
      id: '/_auth/_layout/device/apps/connect'
      path: '/apps/connect'
      fullPath: '/device/apps/connect'
      preLoaderRoute: typeof AuthLayoutDeviceAppsConnectImport
      parentRoute: typeof AuthLayoutDeviceImport
    }
    '/_auth/_layout/device/browser_/connect': {
      id: '/_auth/_layout/device/browser_/connect'
      path: '/browser/connect'
      fullPath: '/device/browser/connect'
      preLoaderRoute: typeof AuthLayoutDeviceBrowserConnectImport
      parentRoute: typeof AuthLayoutDeviceImport
    }
    '/_auth/_layout/device/desktop_/connect': {
      id: '/_auth/_layout/device/desktop_/connect'
      path: '/desktop/connect'
      fullPath: '/device/desktop/connect'
      preLoaderRoute: typeof AuthLayoutDeviceDesktopConnectImport
      parentRoute: typeof AuthLayoutDeviceImport
    }
    '/_auth/_layout/device/mobile_/connect': {
      id: '/_auth/_layout/device/mobile_/connect'
      path: '/mobile/connect'
      fullPath: '/device/mobile/connect'
      preLoaderRoute: typeof AuthLayoutDeviceMobileConnectImport
      parentRoute: typeof AuthLayoutDeviceImport
    }
    '/_auth/_layout/device/remarkable_/connect': {
      id: '/_auth/_layout/device/remarkable_/connect'
      path: '/remarkable/connect'
      fullPath: '/device/remarkable/connect'
      preLoaderRoute: typeof AuthLayoutDeviceRemarkableConnectImport
      parentRoute: typeof AuthLayoutDeviceImport
    }
    '/_auth/_only-header/store/connect-offer/_allowed': {
      id: '/_auth/_only-header/store/connect-offer/_allowed'
      path: ''
      fullPath: '/store/connect-offer'
      preLoaderRoute: typeof AuthOnlyHeaderStoreConnectOfferAllowedImport
      parentRoute: typeof AuthOnlyHeaderStoreConnectOfferImport
    }
    '/_auth/_only-header/store/connect-offer/confirmation': {
      id: '/_auth/_only-header/store/connect-offer/confirmation'
      path: '/confirmation'
      fullPath: '/store/connect-offer/confirmation'
      preLoaderRoute: typeof AuthOnlyHeaderStoreConnectOfferConfirmationImport
      parentRoute: typeof AuthOnlyHeaderStoreConnectOfferImport
    }
    '/_auth/_only-header/store/connect-offer/download-apps': {
      id: '/_auth/_only-header/store/connect-offer/download-apps'
      path: '/download-apps'
      fullPath: '/store/connect-offer/download-apps'
      preLoaderRoute: typeof AuthOnlyHeaderStoreConnectOfferDownloadAppsImport
      parentRoute: typeof AuthOnlyHeaderStoreConnectOfferImport
    }
    '/_auth/_only-header/store/connect-offer/setup-complete': {
      id: '/_auth/_only-header/store/connect-offer/setup-complete'
      path: '/setup-complete'
      fullPath: '/store/connect-offer/setup-complete'
      preLoaderRoute: typeof AuthOnlyHeaderStoreConnectOfferSetupCompleteImport
      parentRoute: typeof AuthOnlyHeaderStoreConnectOfferImport
    }
    '/_auth/_only-header/store/connect': {
      id: '/_auth/_only-header/store/connect'
      path: '/connect'
      fullPath: '/store/connect'
      preLoaderRoute: typeof AuthOnlyHeaderStoreConnectImport
      parentRoute: typeof AuthOnlyHeaderStoreImport
    }
    '/_auth/_only-header/store/connect/_allowed': {
      id: '/_auth/_only-header/store/connect/_allowed'
      path: '/connect'
      fullPath: '/store/connect'
      preLoaderRoute: typeof AuthOnlyHeaderStoreConnectAllowedImport
      parentRoute: typeof AuthOnlyHeaderStoreConnectRoute
    }
    '/_auth/_only-header/store/connect/confirmation': {
      id: '/_auth/_only-header/store/connect/confirmation'
      path: '/confirmation'
      fullPath: '/store/connect/confirmation'
      preLoaderRoute: typeof AuthOnlyHeaderStoreConnectConfirmationImport
      parentRoute: typeof AuthOnlyHeaderStoreConnectImport
    }
    '/_auth/_only-header/store/dm-offer/_allowed': {
      id: '/_auth/_only-header/store/dm-offer/_allowed'
      path: ''
      fullPath: '/store/dm-offer'
      preLoaderRoute: typeof AuthOnlyHeaderStoreDmOfferAllowedImport
      parentRoute: typeof AuthOnlyHeaderStoreDmOfferImport
    }
    '/_auth/_only-header/store/dm-offer/confirmation': {
      id: '/_auth/_only-header/store/dm-offer/confirmation'
      path: '/confirmation'
      fullPath: '/store/dm-offer/confirmation'
      preLoaderRoute: typeof AuthOnlyHeaderStoreDmOfferConfirmationImport
      parentRoute: typeof AuthOnlyHeaderStoreDmOfferImport
    }
    '/_auth/_only-header/store/dm-offer/setup-complete': {
      id: '/_auth/_only-header/store/dm-offer/setup-complete'
      path: '/setup-complete'
      fullPath: '/store/dm-offer/setup-complete'
      preLoaderRoute: typeof AuthOnlyHeaderStoreDmOfferSetupCompleteImport
      parentRoute: typeof AuthOnlyHeaderStoreDmOfferImport
    }
    '/_auth/_only-header/store/methods-offer/_allowed': {
      id: '/_auth/_only-header/store/methods-offer/_allowed'
      path: ''
      fullPath: '/store/methods-offer'
      preLoaderRoute: typeof AuthOnlyHeaderStoreMethodsOfferAllowedImport
      parentRoute: typeof AuthOnlyHeaderStoreMethodsOfferImport
    }
    '/_auth/_only-header/store/methods-offer/confirmation': {
      id: '/_auth/_only-header/store/methods-offer/confirmation'
      path: '/confirmation'
      fullPath: '/store/methods-offer/confirmation'
      preLoaderRoute: typeof AuthOnlyHeaderStoreMethodsOfferConfirmationImport
      parentRoute: typeof AuthOnlyHeaderStoreMethodsOfferImport
    }
    '/_auth/_only-header/store/methods-offer/download-apps': {
      id: '/_auth/_only-header/store/methods-offer/download-apps'
      path: '/download-apps'
      fullPath: '/store/methods-offer/download-apps'
      preLoaderRoute: typeof AuthOnlyHeaderStoreMethodsOfferDownloadAppsImport
      parentRoute: typeof AuthOnlyHeaderStoreMethodsOfferImport
    }
    '/_auth/_only-header/store/methods-offer/setup-complete': {
      id: '/_auth/_only-header/store/methods-offer/setup-complete'
      path: '/setup-complete'
      fullPath: '/store/methods-offer/setup-complete'
      preLoaderRoute: typeof AuthOnlyHeaderStoreMethodsOfferSetupCompleteImport
      parentRoute: typeof AuthOnlyHeaderStoreMethodsOfferImport
    }
    '/_auth/enterprise/_with-org/_layout/billing': {
      id: '/_auth/enterprise/_with-org/_layout/billing'
      path: '/billing'
      fullPath: '/enterprise/billing'
      preLoaderRoute: typeof AuthEnterpriseWithOrgLayoutBillingImport
      parentRoute: typeof AuthEnterpriseWithOrgLayoutImport
    }
    '/_auth/enterprise/_with-org/_layout/devices': {
      id: '/_auth/enterprise/_with-org/_layout/devices'
      path: '/devices'
      fullPath: '/enterprise/devices'
      preLoaderRoute: typeof AuthEnterpriseWithOrgLayoutDevicesImport
      parentRoute: typeof AuthEnterpriseWithOrgLayoutImport
    }
    '/_auth/enterprise/_with-org/_layout/domains': {
      id: '/_auth/enterprise/_with-org/_layout/domains'
      path: '/domains'
      fullPath: '/enterprise/domains'
      preLoaderRoute: typeof AuthEnterpriseWithOrgLayoutDomainsImport
      parentRoute: typeof AuthEnterpriseWithOrgLayoutImport
    }
    '/_auth/enterprise/_with-org/_layout/members': {
      id: '/_auth/enterprise/_with-org/_layout/members'
      path: '/members'
      fullPath: '/enterprise/members'
      preLoaderRoute: typeof AuthEnterpriseWithOrgLayoutMembersImport
      parentRoute: typeof AuthEnterpriseWithOrgLayoutImport
    }
    '/_auth/enterprise/_with-org/_layout/plan': {
      id: '/_auth/enterprise/_with-org/_layout/plan'
      path: '/plan'
      fullPath: '/enterprise/plan'
      preLoaderRoute: typeof AuthEnterpriseWithOrgLayoutPlanImport
      parentRoute: typeof AuthEnterpriseWithOrgLayoutImport
    }
    '/_auth/enterprise/_with-org/_layout/policies': {
      id: '/_auth/enterprise/_with-org/_layout/policies'
      path: '/policies'
      fullPath: '/enterprise/policies'
      preLoaderRoute: typeof AuthEnterpriseWithOrgLayoutPoliciesImport
      parentRoute: typeof AuthEnterpriseWithOrgLayoutImport
    }
    '/_auth/enterprise/_with-org/_layout/settings': {
      id: '/_auth/enterprise/_with-org/_layout/settings'
      path: '/settings'
      fullPath: '/enterprise/settings'
      preLoaderRoute: typeof AuthEnterpriseWithOrgLayoutSettingsImport
      parentRoute: typeof AuthEnterpriseWithOrgLayoutImport
    }
    '/_public/_layout/account/migrate/saml': {
      id: '/_public/_layout/account/migrate/saml'
      path: '/account/migrate/saml'
      fullPath: '/account/migrate/saml'
      preLoaderRoute: typeof PublicLayoutAccountMigrateSamlImport
      parentRoute: typeof PublicLayoutImport
    }
    '/_auth/_layout/account/delete/': {
      id: '/_auth/_layout/account/delete/'
      path: '/'
      fullPath: '/account/delete/'
      preLoaderRoute: typeof AuthLayoutAccountDeleteIndexImport
      parentRoute: typeof AuthLayoutAccountDeleteImport
    }
    '/_auth/_layout/account/migrate/': {
      id: '/_auth/_layout/account/migrate/'
      path: '/migrate'
      fullPath: '/account/migrate'
      preLoaderRoute: typeof AuthLayoutAccountMigrateIndexImport
      parentRoute: typeof AuthLayoutAccountImport
    }
    '/_auth/_layout/device/apps/': {
      id: '/_auth/_layout/device/apps/'
      path: '/apps'
      fullPath: '/device/apps'
      preLoaderRoute: typeof AuthLayoutDeviceAppsIndexImport
      parentRoute: typeof AuthLayoutDeviceImport
    }
    '/_auth/enterprise/_with-org/offboarding/': {
      id: '/_auth/enterprise/_with-org/offboarding/'
      path: '/offboarding'
      fullPath: '/enterprise/offboarding'
      preLoaderRoute: typeof AuthEnterpriseWithOrgOffboardingIndexImport
      parentRoute: typeof AuthEnterpriseWithOrgImport
    }
    '/_auth/(no-layout)/account/delete/confirmation/app': {
      id: '/_auth/(no-layout)/account/delete/confirmation/app'
      path: '/confirmation/app'
      fullPath: '/account/delete/confirmation/app'
      preLoaderRoute: typeof AuthnoLayoutAccountDeleteConfirmationAppImport
      parentRoute: typeof AuthnoLayoutAccountDeleteImport
    }
    '/_auth/(no-layout)/account/delete/landing/app': {
      id: '/_auth/(no-layout)/account/delete/landing/app'
      path: '/landing/app'
      fullPath: '/account/delete/landing/app'
      preLoaderRoute: typeof AuthnoLayoutAccountDeleteLandingAppImport
      parentRoute: typeof AuthnoLayoutAccountDeleteImport
    }
    '/_auth/_only-header/store/connect-offer/_allowed/checkout': {
      id: '/_auth/_only-header/store/connect-offer/_allowed/checkout'
      path: '/checkout'
      fullPath: '/store/connect-offer/checkout'
      preLoaderRoute: typeof AuthOnlyHeaderStoreConnectOfferAllowedCheckoutImport
      parentRoute: typeof AuthOnlyHeaderStoreConnectOfferAllowedImport
    }
    '/_auth/_only-header/store/connect/_allowed/checkout': {
      id: '/_auth/_only-header/store/connect/_allowed/checkout'
      path: '/checkout'
      fullPath: '/store/connect/checkout'
      preLoaderRoute: typeof AuthOnlyHeaderStoreConnectAllowedCheckoutImport
      parentRoute: typeof AuthOnlyHeaderStoreConnectAllowedImport
    }
    '/_auth/_only-header/store/dm-offer/_allowed/checkout': {
      id: '/_auth/_only-header/store/dm-offer/_allowed/checkout'
      path: '/checkout'
      fullPath: '/store/dm-offer/checkout'
      preLoaderRoute: typeof AuthOnlyHeaderStoreDmOfferAllowedCheckoutImport
      parentRoute: typeof AuthOnlyHeaderStoreDmOfferAllowedImport
    }
    '/_auth/_only-header/store/methods-offer/_allowed/checkout': {
      id: '/_auth/_only-header/store/methods-offer/_allowed/checkout'
      path: '/checkout'
      fullPath: '/store/methods-offer/checkout'
      preLoaderRoute: typeof AuthOnlyHeaderStoreMethodsOfferAllowedCheckoutImport
      parentRoute: typeof AuthOnlyHeaderStoreMethodsOfferAllowedImport
    }
    '/_auth/_only-header/store/connect-offer/_allowed/': {
      id: '/_auth/_only-header/store/connect-offer/_allowed/'
      path: '/'
      fullPath: '/store/connect-offer/'
      preLoaderRoute: typeof AuthOnlyHeaderStoreConnectOfferAllowedIndexImport
      parentRoute: typeof AuthOnlyHeaderStoreConnectOfferAllowedImport
    }
    '/_auth/_only-header/store/connect/_allowed/': {
      id: '/_auth/_only-header/store/connect/_allowed/'
      path: '/'
      fullPath: '/store/connect/'
      preLoaderRoute: typeof AuthOnlyHeaderStoreConnectAllowedIndexImport
      parentRoute: typeof AuthOnlyHeaderStoreConnectAllowedImport
    }
    '/_auth/_only-header/store/dm-offer/_allowed/': {
      id: '/_auth/_only-header/store/dm-offer/_allowed/'
      path: '/'
      fullPath: '/store/dm-offer/'
      preLoaderRoute: typeof AuthOnlyHeaderStoreDmOfferAllowedIndexImport
      parentRoute: typeof AuthOnlyHeaderStoreDmOfferAllowedImport
    }
    '/_auth/_only-header/store/methods-offer/_allowed/': {
      id: '/_auth/_only-header/store/methods-offer/_allowed/'
      path: '/'
      fullPath: '/store/methods-offer/'
      preLoaderRoute: typeof AuthOnlyHeaderStoreMethodsOfferAllowedIndexImport
      parentRoute: typeof AuthOnlyHeaderStoreMethodsOfferAllowedImport
    }
  }
}

// Create and export the route tree

interface AuthLayoutAccountDeleteRouteChildren {
  AuthLayoutAccountDeleteConfirmationRoute: typeof AuthLayoutAccountDeleteConfirmationRoute
  AuthLayoutAccountDeleteLandingRoute: typeof AuthLayoutAccountDeleteLandingRoute
  AuthLayoutAccountDeleteIndexRoute: typeof AuthLayoutAccountDeleteIndexRoute
}

const AuthLayoutAccountDeleteRouteChildren: AuthLayoutAccountDeleteRouteChildren =
  {
    AuthLayoutAccountDeleteConfirmationRoute:
      AuthLayoutAccountDeleteConfirmationRoute,
    AuthLayoutAccountDeleteLandingRoute: AuthLayoutAccountDeleteLandingRoute,
    AuthLayoutAccountDeleteIndexRoute: AuthLayoutAccountDeleteIndexRoute,
  }

const AuthLayoutAccountDeleteRouteWithChildren =
  AuthLayoutAccountDeleteRoute._addFileChildren(
    AuthLayoutAccountDeleteRouteChildren,
  )

interface AuthLayoutAccountRouteChildren {
  AuthLayoutAccountDeleteRoute: typeof AuthLayoutAccountDeleteRouteWithChildren
  AuthLayoutAccountIndexRoute: typeof AuthLayoutAccountIndexRoute
  AuthLayoutAccountMigrateSuccessRoute: typeof AuthLayoutAccountMigrateSuccessRoute
  AuthLayoutAccountMigrateIndexRoute: typeof AuthLayoutAccountMigrateIndexRoute
}

const AuthLayoutAccountRouteChildren: AuthLayoutAccountRouteChildren = {
  AuthLayoutAccountDeleteRoute: AuthLayoutAccountDeleteRouteWithChildren,
  AuthLayoutAccountIndexRoute: AuthLayoutAccountIndexRoute,
  AuthLayoutAccountMigrateSuccessRoute: AuthLayoutAccountMigrateSuccessRoute,
  AuthLayoutAccountMigrateIndexRoute: AuthLayoutAccountMigrateIndexRoute,
}

const AuthLayoutAccountRouteWithChildren =
  AuthLayoutAccountRoute._addFileChildren(AuthLayoutAccountRouteChildren)

interface AuthLayoutDeviceRouteChildren {
  AuthLayoutDeviceBrowserRoute: typeof AuthLayoutDeviceBrowserRoute
  AuthLayoutDeviceDesktopRoute: typeof AuthLayoutDeviceDesktopRoute
  AuthLayoutDeviceMobileRoute: typeof AuthLayoutDeviceMobileRoute
  AuthLayoutDeviceRemarkableRoute: typeof AuthLayoutDeviceRemarkableRoute
  AuthLayoutDeviceIndexRoute: typeof AuthLayoutDeviceIndexRoute
  AuthLayoutDeviceAppsConnectRoute: typeof AuthLayoutDeviceAppsConnectRoute
  AuthLayoutDeviceBrowserConnectRoute: typeof AuthLayoutDeviceBrowserConnectRoute
  AuthLayoutDeviceDesktopConnectRoute: typeof AuthLayoutDeviceDesktopConnectRoute
  AuthLayoutDeviceMobileConnectRoute: typeof AuthLayoutDeviceMobileConnectRoute
  AuthLayoutDeviceRemarkableConnectRoute: typeof AuthLayoutDeviceRemarkableConnectRoute
  AuthLayoutDeviceAppsIndexRoute: typeof AuthLayoutDeviceAppsIndexRoute
}

const AuthLayoutDeviceRouteChildren: AuthLayoutDeviceRouteChildren = {
  AuthLayoutDeviceBrowserRoute: AuthLayoutDeviceBrowserRoute,
  AuthLayoutDeviceDesktopRoute: AuthLayoutDeviceDesktopRoute,
  AuthLayoutDeviceMobileRoute: AuthLayoutDeviceMobileRoute,
  AuthLayoutDeviceRemarkableRoute: AuthLayoutDeviceRemarkableRoute,
  AuthLayoutDeviceIndexRoute: AuthLayoutDeviceIndexRoute,
  AuthLayoutDeviceAppsConnectRoute: AuthLayoutDeviceAppsConnectRoute,
  AuthLayoutDeviceBrowserConnectRoute: AuthLayoutDeviceBrowserConnectRoute,
  AuthLayoutDeviceDesktopConnectRoute: AuthLayoutDeviceDesktopConnectRoute,
  AuthLayoutDeviceMobileConnectRoute: AuthLayoutDeviceMobileConnectRoute,
  AuthLayoutDeviceRemarkableConnectRoute:
    AuthLayoutDeviceRemarkableConnectRoute,
  AuthLayoutDeviceAppsIndexRoute: AuthLayoutDeviceAppsIndexRoute,
}

const AuthLayoutDeviceRouteWithChildren =
  AuthLayoutDeviceRoute._addFileChildren(AuthLayoutDeviceRouteChildren)

interface AuthLayoutIntegrationsRouteChildren {
  AuthLayoutIntegrationsCallbackRoute: typeof AuthLayoutIntegrationsCallbackRoute
  AuthLayoutIntegrationsIndexRoute: typeof AuthLayoutIntegrationsIndexRoute
}

const AuthLayoutIntegrationsRouteChildren: AuthLayoutIntegrationsRouteChildren =
  {
    AuthLayoutIntegrationsCallbackRoute: AuthLayoutIntegrationsCallbackRoute,
    AuthLayoutIntegrationsIndexRoute: AuthLayoutIntegrationsIndexRoute,
  }

const AuthLayoutIntegrationsRouteWithChildren =
  AuthLayoutIntegrationsRoute._addFileChildren(
    AuthLayoutIntegrationsRouteChildren,
  )

interface AuthLayoutMyfilesRouteChildren {
  AuthLayoutMyfilesSplatLazyRoute: typeof AuthLayoutMyfilesSplatLazyRoute
}

const AuthLayoutMyfilesRouteChildren: AuthLayoutMyfilesRouteChildren = {
  AuthLayoutMyfilesSplatLazyRoute: AuthLayoutMyfilesSplatLazyRoute,
}

const AuthLayoutMyfilesRouteWithChildren =
  AuthLayoutMyfilesRoute._addFileChildren(AuthLayoutMyfilesRouteChildren)

interface AuthLayoutSubscriptionsRouteChildren {
  AuthLayoutSubscriptionsMembersRoute: typeof AuthLayoutSubscriptionsMembersRoute
  AuthLayoutSubscriptionsPaymentRoute: typeof AuthLayoutSubscriptionsPaymentRoute
  AuthLayoutSubscriptionsPlanRoute: typeof AuthLayoutSubscriptionsPlanRoute
  AuthLayoutSubscriptionsIndexRoute: typeof AuthLayoutSubscriptionsIndexRoute
}

const AuthLayoutSubscriptionsRouteChildren: AuthLayoutSubscriptionsRouteChildren =
  {
    AuthLayoutSubscriptionsMembersRoute: AuthLayoutSubscriptionsMembersRoute,
    AuthLayoutSubscriptionsPaymentRoute: AuthLayoutSubscriptionsPaymentRoute,
    AuthLayoutSubscriptionsPlanRoute: AuthLayoutSubscriptionsPlanRoute,
    AuthLayoutSubscriptionsIndexRoute: AuthLayoutSubscriptionsIndexRoute,
  }

const AuthLayoutSubscriptionsRouteWithChildren =
  AuthLayoutSubscriptionsRoute._addFileChildren(
    AuthLayoutSubscriptionsRouteChildren,
  )

interface AuthLayoutRouteChildren {
  AuthLayoutAccountRoute: typeof AuthLayoutAccountRouteWithChildren
  AuthLayoutDataAccessConsentRoute: typeof AuthLayoutDataAccessConsentRoute
  AuthLayoutDeviceRoute: typeof AuthLayoutDeviceRouteWithChildren
  AuthLayoutIntegrationsRoute: typeof AuthLayoutIntegrationsRouteWithChildren
  AuthLayoutMyfilesRoute: typeof AuthLayoutMyfilesRouteWithChildren
  AuthLayoutSubscriptionsRoute: typeof AuthLayoutSubscriptionsRouteWithChildren
  AuthLayoutIndexRoute: typeof AuthLayoutIndexRoute
  AuthLayoutInvitationSeatRoute: typeof AuthLayoutInvitationSeatRoute
  AuthLayoutPairIndexRoute: typeof AuthLayoutPairIndexRoute
}

const AuthLayoutRouteChildren: AuthLayoutRouteChildren = {
  AuthLayoutAccountRoute: AuthLayoutAccountRouteWithChildren,
  AuthLayoutDataAccessConsentRoute: AuthLayoutDataAccessConsentRoute,
  AuthLayoutDeviceRoute: AuthLayoutDeviceRouteWithChildren,
  AuthLayoutIntegrationsRoute: AuthLayoutIntegrationsRouteWithChildren,
  AuthLayoutMyfilesRoute: AuthLayoutMyfilesRouteWithChildren,
  AuthLayoutSubscriptionsRoute: AuthLayoutSubscriptionsRouteWithChildren,
  AuthLayoutIndexRoute: AuthLayoutIndexRoute,
  AuthLayoutInvitationSeatRoute: AuthLayoutInvitationSeatRoute,
  AuthLayoutPairIndexRoute: AuthLayoutPairIndexRoute,
}

const AuthLayoutRouteWithChildren = AuthLayoutRoute._addFileChildren(
  AuthLayoutRouteChildren,
)

interface AuthOnlyHeaderStoreConnectOfferAllowedRouteChildren {
  AuthOnlyHeaderStoreConnectOfferAllowedCheckoutRoute: typeof AuthOnlyHeaderStoreConnectOfferAllowedCheckoutRoute
  AuthOnlyHeaderStoreConnectOfferAllowedIndexRoute: typeof AuthOnlyHeaderStoreConnectOfferAllowedIndexRoute
}

const AuthOnlyHeaderStoreConnectOfferAllowedRouteChildren: AuthOnlyHeaderStoreConnectOfferAllowedRouteChildren =
  {
    AuthOnlyHeaderStoreConnectOfferAllowedCheckoutRoute:
      AuthOnlyHeaderStoreConnectOfferAllowedCheckoutRoute,
    AuthOnlyHeaderStoreConnectOfferAllowedIndexRoute:
      AuthOnlyHeaderStoreConnectOfferAllowedIndexRoute,
  }

const AuthOnlyHeaderStoreConnectOfferAllowedRouteWithChildren =
  AuthOnlyHeaderStoreConnectOfferAllowedRoute._addFileChildren(
    AuthOnlyHeaderStoreConnectOfferAllowedRouteChildren,
  )

interface AuthOnlyHeaderStoreConnectOfferRouteChildren {
  AuthOnlyHeaderStoreConnectOfferAllowedRoute: typeof AuthOnlyHeaderStoreConnectOfferAllowedRouteWithChildren
  AuthOnlyHeaderStoreConnectOfferConfirmationRoute: typeof AuthOnlyHeaderStoreConnectOfferConfirmationRoute
  AuthOnlyHeaderStoreConnectOfferDownloadAppsRoute: typeof AuthOnlyHeaderStoreConnectOfferDownloadAppsRoute
  AuthOnlyHeaderStoreConnectOfferSetupCompleteRoute: typeof AuthOnlyHeaderStoreConnectOfferSetupCompleteRoute
}

const AuthOnlyHeaderStoreConnectOfferRouteChildren: AuthOnlyHeaderStoreConnectOfferRouteChildren =
  {
    AuthOnlyHeaderStoreConnectOfferAllowedRoute:
      AuthOnlyHeaderStoreConnectOfferAllowedRouteWithChildren,
    AuthOnlyHeaderStoreConnectOfferConfirmationRoute:
      AuthOnlyHeaderStoreConnectOfferConfirmationRoute,
    AuthOnlyHeaderStoreConnectOfferDownloadAppsRoute:
      AuthOnlyHeaderStoreConnectOfferDownloadAppsRoute,
    AuthOnlyHeaderStoreConnectOfferSetupCompleteRoute:
      AuthOnlyHeaderStoreConnectOfferSetupCompleteRoute,
  }

const AuthOnlyHeaderStoreConnectOfferRouteWithChildren =
  AuthOnlyHeaderStoreConnectOfferRoute._addFileChildren(
    AuthOnlyHeaderStoreConnectOfferRouteChildren,
  )

interface AuthOnlyHeaderStoreDmOfferAllowedRouteChildren {
  AuthOnlyHeaderStoreDmOfferAllowedCheckoutRoute: typeof AuthOnlyHeaderStoreDmOfferAllowedCheckoutRoute
  AuthOnlyHeaderStoreDmOfferAllowedIndexRoute: typeof AuthOnlyHeaderStoreDmOfferAllowedIndexRoute
}

const AuthOnlyHeaderStoreDmOfferAllowedRouteChildren: AuthOnlyHeaderStoreDmOfferAllowedRouteChildren =
  {
    AuthOnlyHeaderStoreDmOfferAllowedCheckoutRoute:
      AuthOnlyHeaderStoreDmOfferAllowedCheckoutRoute,
    AuthOnlyHeaderStoreDmOfferAllowedIndexRoute:
      AuthOnlyHeaderStoreDmOfferAllowedIndexRoute,
  }

const AuthOnlyHeaderStoreDmOfferAllowedRouteWithChildren =
  AuthOnlyHeaderStoreDmOfferAllowedRoute._addFileChildren(
    AuthOnlyHeaderStoreDmOfferAllowedRouteChildren,
  )

interface AuthOnlyHeaderStoreDmOfferRouteChildren {
  AuthOnlyHeaderStoreDmOfferAllowedRoute: typeof AuthOnlyHeaderStoreDmOfferAllowedRouteWithChildren
  AuthOnlyHeaderStoreDmOfferConfirmationRoute: typeof AuthOnlyHeaderStoreDmOfferConfirmationRoute
  AuthOnlyHeaderStoreDmOfferSetupCompleteRoute: typeof AuthOnlyHeaderStoreDmOfferSetupCompleteRoute
}

const AuthOnlyHeaderStoreDmOfferRouteChildren: AuthOnlyHeaderStoreDmOfferRouteChildren =
  {
    AuthOnlyHeaderStoreDmOfferAllowedRoute:
      AuthOnlyHeaderStoreDmOfferAllowedRouteWithChildren,
    AuthOnlyHeaderStoreDmOfferConfirmationRoute:
      AuthOnlyHeaderStoreDmOfferConfirmationRoute,
    AuthOnlyHeaderStoreDmOfferSetupCompleteRoute:
      AuthOnlyHeaderStoreDmOfferSetupCompleteRoute,
  }

const AuthOnlyHeaderStoreDmOfferRouteWithChildren =
  AuthOnlyHeaderStoreDmOfferRoute._addFileChildren(
    AuthOnlyHeaderStoreDmOfferRouteChildren,
  )

interface AuthOnlyHeaderStoreMethodsOfferAllowedRouteChildren {
  AuthOnlyHeaderStoreMethodsOfferAllowedCheckoutRoute: typeof AuthOnlyHeaderStoreMethodsOfferAllowedCheckoutRoute
  AuthOnlyHeaderStoreMethodsOfferAllowedIndexRoute: typeof AuthOnlyHeaderStoreMethodsOfferAllowedIndexRoute
}

const AuthOnlyHeaderStoreMethodsOfferAllowedRouteChildren: AuthOnlyHeaderStoreMethodsOfferAllowedRouteChildren =
  {
    AuthOnlyHeaderStoreMethodsOfferAllowedCheckoutRoute:
      AuthOnlyHeaderStoreMethodsOfferAllowedCheckoutRoute,
    AuthOnlyHeaderStoreMethodsOfferAllowedIndexRoute:
      AuthOnlyHeaderStoreMethodsOfferAllowedIndexRoute,
  }

const AuthOnlyHeaderStoreMethodsOfferAllowedRouteWithChildren =
  AuthOnlyHeaderStoreMethodsOfferAllowedRoute._addFileChildren(
    AuthOnlyHeaderStoreMethodsOfferAllowedRouteChildren,
  )

interface AuthOnlyHeaderStoreMethodsOfferRouteChildren {
  AuthOnlyHeaderStoreMethodsOfferAllowedRoute: typeof AuthOnlyHeaderStoreMethodsOfferAllowedRouteWithChildren
  AuthOnlyHeaderStoreMethodsOfferConfirmationRoute: typeof AuthOnlyHeaderStoreMethodsOfferConfirmationRoute
  AuthOnlyHeaderStoreMethodsOfferDownloadAppsRoute: typeof AuthOnlyHeaderStoreMethodsOfferDownloadAppsRoute
  AuthOnlyHeaderStoreMethodsOfferSetupCompleteRoute: typeof AuthOnlyHeaderStoreMethodsOfferSetupCompleteRoute
}

const AuthOnlyHeaderStoreMethodsOfferRouteChildren: AuthOnlyHeaderStoreMethodsOfferRouteChildren =
  {
    AuthOnlyHeaderStoreMethodsOfferAllowedRoute:
      AuthOnlyHeaderStoreMethodsOfferAllowedRouteWithChildren,
    AuthOnlyHeaderStoreMethodsOfferConfirmationRoute:
      AuthOnlyHeaderStoreMethodsOfferConfirmationRoute,
    AuthOnlyHeaderStoreMethodsOfferDownloadAppsRoute:
      AuthOnlyHeaderStoreMethodsOfferDownloadAppsRoute,
    AuthOnlyHeaderStoreMethodsOfferSetupCompleteRoute:
      AuthOnlyHeaderStoreMethodsOfferSetupCompleteRoute,
  }

const AuthOnlyHeaderStoreMethodsOfferRouteWithChildren =
  AuthOnlyHeaderStoreMethodsOfferRoute._addFileChildren(
    AuthOnlyHeaderStoreMethodsOfferRouteChildren,
  )

interface AuthOnlyHeaderStoreConnectAllowedRouteChildren {
  AuthOnlyHeaderStoreConnectAllowedCheckoutRoute: typeof AuthOnlyHeaderStoreConnectAllowedCheckoutRoute
  AuthOnlyHeaderStoreConnectAllowedIndexRoute: typeof AuthOnlyHeaderStoreConnectAllowedIndexRoute
}

const AuthOnlyHeaderStoreConnectAllowedRouteChildren: AuthOnlyHeaderStoreConnectAllowedRouteChildren =
  {
    AuthOnlyHeaderStoreConnectAllowedCheckoutRoute:
      AuthOnlyHeaderStoreConnectAllowedCheckoutRoute,
    AuthOnlyHeaderStoreConnectAllowedIndexRoute:
      AuthOnlyHeaderStoreConnectAllowedIndexRoute,
  }

const AuthOnlyHeaderStoreConnectAllowedRouteWithChildren =
  AuthOnlyHeaderStoreConnectAllowedRoute._addFileChildren(
    AuthOnlyHeaderStoreConnectAllowedRouteChildren,
  )

interface AuthOnlyHeaderStoreConnectRouteChildren {
  AuthOnlyHeaderStoreConnectAllowedRoute: typeof AuthOnlyHeaderStoreConnectAllowedRouteWithChildren
  AuthOnlyHeaderStoreConnectConfirmationRoute: typeof AuthOnlyHeaderStoreConnectConfirmationRoute
}

const AuthOnlyHeaderStoreConnectRouteChildren: AuthOnlyHeaderStoreConnectRouteChildren =
  {
    AuthOnlyHeaderStoreConnectAllowedRoute:
      AuthOnlyHeaderStoreConnectAllowedRouteWithChildren,
    AuthOnlyHeaderStoreConnectConfirmationRoute:
      AuthOnlyHeaderStoreConnectConfirmationRoute,
  }

const AuthOnlyHeaderStoreConnectRouteWithChildren =
  AuthOnlyHeaderStoreConnectRoute._addFileChildren(
    AuthOnlyHeaderStoreConnectRouteChildren,
  )

interface AuthOnlyHeaderStoreRouteChildren {
  AuthOnlyHeaderStoreCheckoutRoute: typeof AuthOnlyHeaderStoreCheckoutRoute
  AuthOnlyHeaderStoreCheckoutReturnRoute: typeof AuthOnlyHeaderStoreCheckoutReturnRoute
  AuthOnlyHeaderStoreConfirmationRoute: typeof AuthOnlyHeaderStoreConfirmationRoute
  AuthOnlyHeaderStoreConnectOfferRoute: typeof AuthOnlyHeaderStoreConnectOfferRouteWithChildren
  AuthOnlyHeaderStoreDmOfferRoute: typeof AuthOnlyHeaderStoreDmOfferRouteWithChildren
  AuthOnlyHeaderStoreMethodsOfferRoute: typeof AuthOnlyHeaderStoreMethodsOfferRouteWithChildren
  AuthOnlyHeaderStoreIndexRoute: typeof AuthOnlyHeaderStoreIndexRoute
  AuthOnlyHeaderStoreConnectRoute: typeof AuthOnlyHeaderStoreConnectRouteWithChildren
}

const AuthOnlyHeaderStoreRouteChildren: AuthOnlyHeaderStoreRouteChildren = {
  AuthOnlyHeaderStoreCheckoutRoute: AuthOnlyHeaderStoreCheckoutRoute,
  AuthOnlyHeaderStoreCheckoutReturnRoute:
    AuthOnlyHeaderStoreCheckoutReturnRoute,
  AuthOnlyHeaderStoreConfirmationRoute: AuthOnlyHeaderStoreConfirmationRoute,
  AuthOnlyHeaderStoreConnectOfferRoute:
    AuthOnlyHeaderStoreConnectOfferRouteWithChildren,
  AuthOnlyHeaderStoreDmOfferRoute: AuthOnlyHeaderStoreDmOfferRouteWithChildren,
  AuthOnlyHeaderStoreMethodsOfferRoute:
    AuthOnlyHeaderStoreMethodsOfferRouteWithChildren,
  AuthOnlyHeaderStoreIndexRoute: AuthOnlyHeaderStoreIndexRoute,
  AuthOnlyHeaderStoreConnectRoute: AuthOnlyHeaderStoreConnectRouteWithChildren,
}

const AuthOnlyHeaderStoreRouteWithChildren =
  AuthOnlyHeaderStoreRoute._addFileChildren(AuthOnlyHeaderStoreRouteChildren)

interface AuthOnlyHeaderRouteChildren {
  AuthOnlyHeaderStoreRoute: typeof AuthOnlyHeaderStoreRouteWithChildren
  AuthOnlyHeaderVerifyNewEmailRoute: typeof AuthOnlyHeaderVerifyNewEmailRoute
}

const AuthOnlyHeaderRouteChildren: AuthOnlyHeaderRouteChildren = {
  AuthOnlyHeaderStoreRoute: AuthOnlyHeaderStoreRouteWithChildren,
  AuthOnlyHeaderVerifyNewEmailRoute: AuthOnlyHeaderVerifyNewEmailRoute,
}

const AuthOnlyHeaderRouteWithChildren = AuthOnlyHeaderRoute._addFileChildren(
  AuthOnlyHeaderRouteChildren,
)

interface AuthEnterpriseWithOrgLayoutRouteChildren {
  AuthEnterpriseWithOrgLayoutBillingRoute: typeof AuthEnterpriseWithOrgLayoutBillingRoute
  AuthEnterpriseWithOrgLayoutDevicesRoute: typeof AuthEnterpriseWithOrgLayoutDevicesRoute
  AuthEnterpriseWithOrgLayoutDomainsRoute: typeof AuthEnterpriseWithOrgLayoutDomainsRoute
  AuthEnterpriseWithOrgLayoutMembersRoute: typeof AuthEnterpriseWithOrgLayoutMembersRoute
  AuthEnterpriseWithOrgLayoutPlanRoute: typeof AuthEnterpriseWithOrgLayoutPlanRoute
  AuthEnterpriseWithOrgLayoutPoliciesRoute: typeof AuthEnterpriseWithOrgLayoutPoliciesRoute
  AuthEnterpriseWithOrgLayoutSettingsRoute: typeof AuthEnterpriseWithOrgLayoutSettingsRoute
}

const AuthEnterpriseWithOrgLayoutRouteChildren: AuthEnterpriseWithOrgLayoutRouteChildren =
  {
    AuthEnterpriseWithOrgLayoutBillingRoute:
      AuthEnterpriseWithOrgLayoutBillingRoute,
    AuthEnterpriseWithOrgLayoutDevicesRoute:
      AuthEnterpriseWithOrgLayoutDevicesRoute,
    AuthEnterpriseWithOrgLayoutDomainsRoute:
      AuthEnterpriseWithOrgLayoutDomainsRoute,
    AuthEnterpriseWithOrgLayoutMembersRoute:
      AuthEnterpriseWithOrgLayoutMembersRoute,
    AuthEnterpriseWithOrgLayoutPlanRoute: AuthEnterpriseWithOrgLayoutPlanRoute,
    AuthEnterpriseWithOrgLayoutPoliciesRoute:
      AuthEnterpriseWithOrgLayoutPoliciesRoute,
    AuthEnterpriseWithOrgLayoutSettingsRoute:
      AuthEnterpriseWithOrgLayoutSettingsRoute,
  }

const AuthEnterpriseWithOrgLayoutRouteWithChildren =
  AuthEnterpriseWithOrgLayoutRoute._addFileChildren(
    AuthEnterpriseWithOrgLayoutRouteChildren,
  )

interface AuthEnterpriseWithOrgRouteChildren {
  AuthEnterpriseWithOrgLayoutRoute: typeof AuthEnterpriseWithOrgLayoutRouteWithChildren
  AuthEnterpriseWithOrgOffboardingIndexRoute: typeof AuthEnterpriseWithOrgOffboardingIndexRoute
}

const AuthEnterpriseWithOrgRouteChildren: AuthEnterpriseWithOrgRouteChildren = {
  AuthEnterpriseWithOrgLayoutRoute:
    AuthEnterpriseWithOrgLayoutRouteWithChildren,
  AuthEnterpriseWithOrgOffboardingIndexRoute:
    AuthEnterpriseWithOrgOffboardingIndexRoute,
}

const AuthEnterpriseWithOrgRouteWithChildren =
  AuthEnterpriseWithOrgRoute._addFileChildren(
    AuthEnterpriseWithOrgRouteChildren,
  )

interface AuthEnterpriseEnrollRouteChildren {
  AuthEnterpriseEnrollConfirmSetupRoute: typeof AuthEnterpriseEnrollConfirmSetupRoute
  AuthEnterpriseEnrollCreateOrganizationRoute: typeof AuthEnterpriseEnrollCreateOrganizationRoute
  AuthEnterpriseEnrollSetupRoute: typeof AuthEnterpriseEnrollSetupRoute
  AuthEnterpriseEnrollSetupSamlRoute: typeof AuthEnterpriseEnrollSetupSamlRoute
  AuthEnterpriseEnrollVerifyDomainRoute: typeof AuthEnterpriseEnrollVerifyDomainRoute
  AuthEnterpriseEnrollVerifySamlRoute: typeof AuthEnterpriseEnrollVerifySamlRoute
  AuthEnterpriseEnrollIndexRoute: typeof AuthEnterpriseEnrollIndexRoute
}

const AuthEnterpriseEnrollRouteChildren: AuthEnterpriseEnrollRouteChildren = {
  AuthEnterpriseEnrollConfirmSetupRoute: AuthEnterpriseEnrollConfirmSetupRoute,
  AuthEnterpriseEnrollCreateOrganizationRoute:
    AuthEnterpriseEnrollCreateOrganizationRoute,
  AuthEnterpriseEnrollSetupRoute: AuthEnterpriseEnrollSetupRoute,
  AuthEnterpriseEnrollSetupSamlRoute: AuthEnterpriseEnrollSetupSamlRoute,
  AuthEnterpriseEnrollVerifyDomainRoute: AuthEnterpriseEnrollVerifyDomainRoute,
  AuthEnterpriseEnrollVerifySamlRoute: AuthEnterpriseEnrollVerifySamlRoute,
  AuthEnterpriseEnrollIndexRoute: AuthEnterpriseEnrollIndexRoute,
}

const AuthEnterpriseEnrollRouteWithChildren =
  AuthEnterpriseEnrollRoute._addFileChildren(AuthEnterpriseEnrollRouteChildren)

interface AuthEnterpriseRouteChildren {
  AuthEnterpriseWithOrgRoute: typeof AuthEnterpriseWithOrgRouteWithChildren
  AuthEnterpriseEnrollRoute: typeof AuthEnterpriseEnrollRouteWithChildren
  AuthEnterpriseLinkRoute: typeof AuthEnterpriseLinkRoute
  AuthEnterpriseIndexRoute: typeof AuthEnterpriseIndexRoute
}

const AuthEnterpriseRouteChildren: AuthEnterpriseRouteChildren = {
  AuthEnterpriseWithOrgRoute: AuthEnterpriseWithOrgRouteWithChildren,
  AuthEnterpriseEnrollRoute: AuthEnterpriseEnrollRouteWithChildren,
  AuthEnterpriseLinkRoute: AuthEnterpriseLinkRoute,
  AuthEnterpriseIndexRoute: AuthEnterpriseIndexRoute,
}

const AuthEnterpriseRouteWithChildren = AuthEnterpriseRoute._addFileChildren(
  AuthEnterpriseRouteChildren,
)

interface AuthnoLayoutAccountDeleteRouteChildren {
  AuthnoLayoutAccountDeleteConfirmationAppRoute: typeof AuthnoLayoutAccountDeleteConfirmationAppRoute
  AuthnoLayoutAccountDeleteLandingAppRoute: typeof AuthnoLayoutAccountDeleteLandingAppRoute
}

const AuthnoLayoutAccountDeleteRouteChildren: AuthnoLayoutAccountDeleteRouteChildren =
  {
    AuthnoLayoutAccountDeleteConfirmationAppRoute:
      AuthnoLayoutAccountDeleteConfirmationAppRoute,
    AuthnoLayoutAccountDeleteLandingAppRoute:
      AuthnoLayoutAccountDeleteLandingAppRoute,
  }

const AuthnoLayoutAccountDeleteRouteWithChildren =
  AuthnoLayoutAccountDeleteRoute._addFileChildren(
    AuthnoLayoutAccountDeleteRouteChildren,
  )

interface AuthRouteChildren {
  AuthLayoutRoute: typeof AuthLayoutRouteWithChildren
  AuthOnlyHeaderRoute: typeof AuthOnlyHeaderRouteWithChildren
  AuthEnterpriseRoute: typeof AuthEnterpriseRouteWithChildren
  AuthnoLayoutVerifiedRoute: typeof AuthnoLayoutVerifiedRoute
  AuthPairAppRoute: typeof AuthPairAppRoute
  AuthnoLayoutAccountDeleteRoute: typeof AuthnoLayoutAccountDeleteRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLayoutRoute: AuthLayoutRouteWithChildren,
  AuthOnlyHeaderRoute: AuthOnlyHeaderRouteWithChildren,
  AuthEnterpriseRoute: AuthEnterpriseRouteWithChildren,
  AuthnoLayoutVerifiedRoute: AuthnoLayoutVerifiedRoute,
  AuthPairAppRoute: AuthPairAppRoute,
  AuthnoLayoutAccountDeleteRoute: AuthnoLayoutAccountDeleteRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PublicLayoutRouteChildren {
  PublicLayoutAccountMigrateSamlRoute: typeof PublicLayoutAccountMigrateSamlRoute
}

const PublicLayoutRouteChildren: PublicLayoutRouteChildren = {
  PublicLayoutAccountMigrateSamlRoute: PublicLayoutAccountMigrateSamlRoute,
}

const PublicLayoutRouteWithChildren = PublicLayoutRoute._addFileChildren(
  PublicLayoutRouteChildren,
)

interface PublicRouteChildren {
  PublicLayoutRoute: typeof PublicLayoutRouteWithChildren
  PublicAccessDeniedRoute: typeof PublicAccessDeniedRoute
  PublicAuthenticationErrorRoute: typeof PublicAuthenticationErrorRoute
  PublicConnectForBusinessRoute: typeof PublicConnectForBusinessRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicLogoutRoute: typeof PublicLogoutRoute
  PublicMethodNotSupportedRoute: typeof PublicMethodNotSupportedRoute
  PublicSamlErrorRoute: typeof PublicSamlErrorRoute
  PublicTestDataRoute: typeof PublicTestDataRoute
  PublicDownloadsMobileAppRoute: typeof PublicDownloadsMobileAppRoute
  PublicLandingPageDeviceSetupRoute: typeof PublicLandingPageDeviceSetupRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLayoutRoute: PublicLayoutRouteWithChildren,
  PublicAccessDeniedRoute: PublicAccessDeniedRoute,
  PublicAuthenticationErrorRoute: PublicAuthenticationErrorRoute,
  PublicConnectForBusinessRoute: PublicConnectForBusinessRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicLogoutRoute: PublicLogoutRoute,
  PublicMethodNotSupportedRoute: PublicMethodNotSupportedRoute,
  PublicSamlErrorRoute: PublicSamlErrorRoute,
  PublicTestDataRoute: PublicTestDataRoute,
  PublicDownloadsMobileAppRoute: PublicDownloadsMobileAppRoute,
  PublicLandingPageDeviceSetupRoute: PublicLandingPageDeviceSetupRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

interface redirectsFleetRouteChildren {
  redirectsFleetMembersRoute: typeof redirectsFleetMembersRoute
}

const redirectsFleetRouteChildren: redirectsFleetRouteChildren = {
  redirectsFleetMembersRoute: redirectsFleetMembersRoute,
}

const redirectsFleetRouteWithChildren = redirectsFleetRoute._addFileChildren(
  redirectsFleetRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof PublicLayoutRouteWithChildren
  '/checkout': typeof redirectsCheckoutRoute
  '/fleet': typeof redirectsFleetRouteWithChildren
  '/settings': typeof redirectsSettingsRoute
  '/enterprise': typeof AuthEnterpriseWithOrgLayoutRouteWithChildren
  '/access-denied': typeof PublicAccessDeniedRoute
  '/authentication-error': typeof PublicAuthenticationErrorRoute
  '/connect-for-business': typeof PublicConnectForBusinessRoute
  '/login': typeof PublicLoginRoute
  '/logout': typeof PublicLogoutRoute
  '/method-not-supported': typeof PublicMethodNotSupportedRoute
  '/saml-error': typeof PublicSamlErrorRoute
  '/test-data': typeof PublicTestDataRoute
  '/fleet/members': typeof redirectsFleetMembersRoute
  '/verified': typeof AuthnoLayoutVerifiedRoute
  '/account': typeof AuthLayoutAccountRouteWithChildren
  '/data-access-consent': typeof AuthLayoutDataAccessConsentRoute
  '/device': typeof AuthLayoutDeviceRouteWithChildren
  '/integrations': typeof AuthLayoutIntegrationsRouteWithChildren
  '/myfiles': typeof AuthLayoutMyfilesRouteWithChildren
  '/subscriptions': typeof AuthLayoutSubscriptionsRouteWithChildren
  '/store': typeof AuthOnlyHeaderStoreRouteWithChildren
  '/verify-new-email': typeof AuthOnlyHeaderVerifyNewEmailRoute
  '/enterprise/enroll': typeof AuthEnterpriseEnrollRouteWithChildren
  '/enterprise/link': typeof AuthEnterpriseLinkRoute
  '/pair/app': typeof AuthPairAppRoute
  '/downloads/mobile-app': typeof PublicDownloadsMobileAppRoute
  '/landing-page/device-setup': typeof PublicLandingPageDeviceSetupRoute
  '/': typeof AuthLayoutIndexRoute
  '/enterprise/': typeof AuthEnterpriseIndexRoute
  '/account/delete': typeof AuthLayoutAccountDeleteRouteWithChildren
  '/device/browser': typeof AuthLayoutDeviceBrowserRoute
  '/device/desktop': typeof AuthLayoutDeviceDesktopRoute
  '/device/mobile': typeof AuthLayoutDeviceMobileRoute
  '/device/remarkable': typeof AuthLayoutDeviceRemarkableRoute
  '/integrations/callback': typeof AuthLayoutIntegrationsCallbackRoute
  '/invitation/seat': typeof AuthLayoutInvitationSeatRoute
  '/subscriptions/members': typeof AuthLayoutSubscriptionsMembersRoute
  '/subscriptions/payment': typeof AuthLayoutSubscriptionsPaymentRoute
  '/subscriptions/plan': typeof AuthLayoutSubscriptionsPlanRoute
  '/store/checkout': typeof AuthOnlyHeaderStoreCheckoutRoute
  '/store/checkout-return': typeof AuthOnlyHeaderStoreCheckoutReturnRoute
  '/store/confirmation': typeof AuthOnlyHeaderStoreConfirmationRoute
  '/store/connect-offer': typeof AuthOnlyHeaderStoreConnectOfferAllowedRouteWithChildren
  '/store/dm-offer': typeof AuthOnlyHeaderStoreDmOfferAllowedRouteWithChildren
  '/store/methods-offer': typeof AuthOnlyHeaderStoreMethodsOfferAllowedRouteWithChildren
  '/enterprise/enroll/confirm-setup': typeof AuthEnterpriseEnrollConfirmSetupRoute
  '/enterprise/enroll/create-organization': typeof AuthEnterpriseEnrollCreateOrganizationRoute
  '/enterprise/enroll/setup': typeof AuthEnterpriseEnrollSetupRoute
  '/enterprise/enroll/setup-saml': typeof AuthEnterpriseEnrollSetupSamlRoute
  '/enterprise/enroll/verify-domain': typeof AuthEnterpriseEnrollVerifyDomainRoute
  '/enterprise/enroll/verify-saml': typeof AuthEnterpriseEnrollVerifySamlRoute
  '/myfiles/$': typeof AuthLayoutMyfilesSplatLazyRoute
  '/account/': typeof AuthLayoutAccountIndexRoute
  '/device/': typeof AuthLayoutDeviceIndexRoute
  '/integrations/': typeof AuthLayoutIntegrationsIndexRoute
  '/pair': typeof AuthLayoutPairIndexRoute
  '/subscriptions/': typeof AuthLayoutSubscriptionsIndexRoute
  '/store/': typeof AuthOnlyHeaderStoreIndexRoute
  '/enterprise/enroll/': typeof AuthEnterpriseEnrollIndexRoute
  '/account/delete/confirmation': typeof AuthLayoutAccountDeleteConfirmationRoute
  '/account/delete/landing': typeof AuthLayoutAccountDeleteLandingRoute
  '/account/migrate/success': typeof AuthLayoutAccountMigrateSuccessRoute
  '/device/apps/connect': typeof AuthLayoutDeviceAppsConnectRoute
  '/device/browser/connect': typeof AuthLayoutDeviceBrowserConnectRoute
  '/device/desktop/connect': typeof AuthLayoutDeviceDesktopConnectRoute
  '/device/mobile/connect': typeof AuthLayoutDeviceMobileConnectRoute
  '/device/remarkable/connect': typeof AuthLayoutDeviceRemarkableConnectRoute
  '/store/connect-offer/confirmation': typeof AuthOnlyHeaderStoreConnectOfferConfirmationRoute
  '/store/connect-offer/download-apps': typeof AuthOnlyHeaderStoreConnectOfferDownloadAppsRoute
  '/store/connect-offer/setup-complete': typeof AuthOnlyHeaderStoreConnectOfferSetupCompleteRoute
  '/store/connect': typeof AuthOnlyHeaderStoreConnectAllowedRouteWithChildren
  '/store/connect/confirmation': typeof AuthOnlyHeaderStoreConnectConfirmationRoute
  '/store/dm-offer/confirmation': typeof AuthOnlyHeaderStoreDmOfferConfirmationRoute
  '/store/dm-offer/setup-complete': typeof AuthOnlyHeaderStoreDmOfferSetupCompleteRoute
  '/store/methods-offer/confirmation': typeof AuthOnlyHeaderStoreMethodsOfferConfirmationRoute
  '/store/methods-offer/download-apps': typeof AuthOnlyHeaderStoreMethodsOfferDownloadAppsRoute
  '/store/methods-offer/setup-complete': typeof AuthOnlyHeaderStoreMethodsOfferSetupCompleteRoute
  '/enterprise/billing': typeof AuthEnterpriseWithOrgLayoutBillingRoute
  '/enterprise/devices': typeof AuthEnterpriseWithOrgLayoutDevicesRoute
  '/enterprise/domains': typeof AuthEnterpriseWithOrgLayoutDomainsRoute
  '/enterprise/members': typeof AuthEnterpriseWithOrgLayoutMembersRoute
  '/enterprise/plan': typeof AuthEnterpriseWithOrgLayoutPlanRoute
  '/enterprise/policies': typeof AuthEnterpriseWithOrgLayoutPoliciesRoute
  '/enterprise/settings': typeof AuthEnterpriseWithOrgLayoutSettingsRoute
  '/account/migrate/saml': typeof PublicLayoutAccountMigrateSamlRoute
  '/account/delete/': typeof AuthLayoutAccountDeleteIndexRoute
  '/account/migrate': typeof AuthLayoutAccountMigrateIndexRoute
  '/device/apps': typeof AuthLayoutDeviceAppsIndexRoute
  '/enterprise/offboarding': typeof AuthEnterpriseWithOrgOffboardingIndexRoute
  '/account/delete/confirmation/app': typeof AuthnoLayoutAccountDeleteConfirmationAppRoute
  '/account/delete/landing/app': typeof AuthnoLayoutAccountDeleteLandingAppRoute
  '/store/connect-offer/checkout': typeof AuthOnlyHeaderStoreConnectOfferAllowedCheckoutRoute
  '/store/connect/checkout': typeof AuthOnlyHeaderStoreConnectAllowedCheckoutRoute
  '/store/dm-offer/checkout': typeof AuthOnlyHeaderStoreDmOfferAllowedCheckoutRoute
  '/store/methods-offer/checkout': typeof AuthOnlyHeaderStoreMethodsOfferAllowedCheckoutRoute
  '/store/connect-offer/': typeof AuthOnlyHeaderStoreConnectOfferAllowedIndexRoute
  '/store/connect/': typeof AuthOnlyHeaderStoreConnectAllowedIndexRoute
  '/store/dm-offer/': typeof AuthOnlyHeaderStoreDmOfferAllowedIndexRoute
  '/store/methods-offer/': typeof AuthOnlyHeaderStoreMethodsOfferAllowedIndexRoute
}

export interface FileRoutesByTo {
  '': typeof PublicLayoutRouteWithChildren
  '/checkout': typeof redirectsCheckoutRoute
  '/fleet': typeof redirectsFleetRouteWithChildren
  '/settings': typeof redirectsSettingsRoute
  '/access-denied': typeof PublicAccessDeniedRoute
  '/authentication-error': typeof PublicAuthenticationErrorRoute
  '/connect-for-business': typeof PublicConnectForBusinessRoute
  '/login': typeof PublicLoginRoute
  '/logout': typeof PublicLogoutRoute
  '/method-not-supported': typeof PublicMethodNotSupportedRoute
  '/saml-error': typeof PublicSamlErrorRoute
  '/test-data': typeof PublicTestDataRoute
  '/fleet/members': typeof redirectsFleetMembersRoute
  '/verified': typeof AuthnoLayoutVerifiedRoute
  '/data-access-consent': typeof AuthLayoutDataAccessConsentRoute
  '/myfiles': typeof AuthLayoutMyfilesRouteWithChildren
  '/verify-new-email': typeof AuthOnlyHeaderVerifyNewEmailRoute
  '/enterprise': typeof AuthEnterpriseWithOrgLayoutRouteWithChildren
  '/enterprise/link': typeof AuthEnterpriseLinkRoute
  '/pair/app': typeof AuthPairAppRoute
  '/downloads/mobile-app': typeof PublicDownloadsMobileAppRoute
  '/landing-page/device-setup': typeof PublicLandingPageDeviceSetupRoute
  '/': typeof AuthLayoutIndexRoute
  '/account/delete': typeof AuthLayoutAccountDeleteIndexRoute
  '/device/browser': typeof AuthLayoutDeviceBrowserRoute
  '/device/desktop': typeof AuthLayoutDeviceDesktopRoute
  '/device/mobile': typeof AuthLayoutDeviceMobileRoute
  '/device/remarkable': typeof AuthLayoutDeviceRemarkableRoute
  '/integrations/callback': typeof AuthLayoutIntegrationsCallbackRoute
  '/invitation/seat': typeof AuthLayoutInvitationSeatRoute
  '/subscriptions/members': typeof AuthLayoutSubscriptionsMembersRoute
  '/subscriptions/payment': typeof AuthLayoutSubscriptionsPaymentRoute
  '/subscriptions/plan': typeof AuthLayoutSubscriptionsPlanRoute
  '/store/checkout': typeof AuthOnlyHeaderStoreCheckoutRoute
  '/store/checkout-return': typeof AuthOnlyHeaderStoreCheckoutReturnRoute
  '/store/confirmation': typeof AuthOnlyHeaderStoreConfirmationRoute
  '/store/connect-offer': typeof AuthOnlyHeaderStoreConnectOfferAllowedIndexRoute
  '/store/dm-offer': typeof AuthOnlyHeaderStoreDmOfferAllowedIndexRoute
  '/store/methods-offer': typeof AuthOnlyHeaderStoreMethodsOfferAllowedIndexRoute
  '/enterprise/enroll/confirm-setup': typeof AuthEnterpriseEnrollConfirmSetupRoute
  '/enterprise/enroll/create-organization': typeof AuthEnterpriseEnrollCreateOrganizationRoute
  '/enterprise/enroll/setup': typeof AuthEnterpriseEnrollSetupRoute
  '/enterprise/enroll/setup-saml': typeof AuthEnterpriseEnrollSetupSamlRoute
  '/enterprise/enroll/verify-domain': typeof AuthEnterpriseEnrollVerifyDomainRoute
  '/enterprise/enroll/verify-saml': typeof AuthEnterpriseEnrollVerifySamlRoute
  '/myfiles/$': typeof AuthLayoutMyfilesSplatLazyRoute
  '/account': typeof AuthLayoutAccountIndexRoute
  '/device': typeof AuthLayoutDeviceIndexRoute
  '/integrations': typeof AuthLayoutIntegrationsIndexRoute
  '/pair': typeof AuthLayoutPairIndexRoute
  '/subscriptions': typeof AuthLayoutSubscriptionsIndexRoute
  '/store': typeof AuthOnlyHeaderStoreIndexRoute
  '/enterprise/enroll': typeof AuthEnterpriseEnrollIndexRoute
  '/account/delete/confirmation': typeof AuthLayoutAccountDeleteConfirmationRoute
  '/account/delete/landing': typeof AuthLayoutAccountDeleteLandingRoute
  '/account/migrate/success': typeof AuthLayoutAccountMigrateSuccessRoute
  '/device/apps/connect': typeof AuthLayoutDeviceAppsConnectRoute
  '/device/browser/connect': typeof AuthLayoutDeviceBrowserConnectRoute
  '/device/desktop/connect': typeof AuthLayoutDeviceDesktopConnectRoute
  '/device/mobile/connect': typeof AuthLayoutDeviceMobileConnectRoute
  '/device/remarkable/connect': typeof AuthLayoutDeviceRemarkableConnectRoute
  '/store/connect-offer/confirmation': typeof AuthOnlyHeaderStoreConnectOfferConfirmationRoute
  '/store/connect-offer/download-apps': typeof AuthOnlyHeaderStoreConnectOfferDownloadAppsRoute
  '/store/connect-offer/setup-complete': typeof AuthOnlyHeaderStoreConnectOfferSetupCompleteRoute
  '/store/connect': typeof AuthOnlyHeaderStoreConnectAllowedIndexRoute
  '/store/connect/confirmation': typeof AuthOnlyHeaderStoreConnectConfirmationRoute
  '/store/dm-offer/confirmation': typeof AuthOnlyHeaderStoreDmOfferConfirmationRoute
  '/store/dm-offer/setup-complete': typeof AuthOnlyHeaderStoreDmOfferSetupCompleteRoute
  '/store/methods-offer/confirmation': typeof AuthOnlyHeaderStoreMethodsOfferConfirmationRoute
  '/store/methods-offer/download-apps': typeof AuthOnlyHeaderStoreMethodsOfferDownloadAppsRoute
  '/store/methods-offer/setup-complete': typeof AuthOnlyHeaderStoreMethodsOfferSetupCompleteRoute
  '/enterprise/billing': typeof AuthEnterpriseWithOrgLayoutBillingRoute
  '/enterprise/devices': typeof AuthEnterpriseWithOrgLayoutDevicesRoute
  '/enterprise/domains': typeof AuthEnterpriseWithOrgLayoutDomainsRoute
  '/enterprise/members': typeof AuthEnterpriseWithOrgLayoutMembersRoute
  '/enterprise/plan': typeof AuthEnterpriseWithOrgLayoutPlanRoute
  '/enterprise/policies': typeof AuthEnterpriseWithOrgLayoutPoliciesRoute
  '/enterprise/settings': typeof AuthEnterpriseWithOrgLayoutSettingsRoute
  '/account/migrate/saml': typeof PublicLayoutAccountMigrateSamlRoute
  '/account/migrate': typeof AuthLayoutAccountMigrateIndexRoute
  '/device/apps': typeof AuthLayoutDeviceAppsIndexRoute
  '/enterprise/offboarding': typeof AuthEnterpriseWithOrgOffboardingIndexRoute
  '/account/delete/confirmation/app': typeof AuthnoLayoutAccountDeleteConfirmationAppRoute
  '/account/delete/landing/app': typeof AuthnoLayoutAccountDeleteLandingAppRoute
  '/store/connect-offer/checkout': typeof AuthOnlyHeaderStoreConnectOfferAllowedCheckoutRoute
  '/store/connect/checkout': typeof AuthOnlyHeaderStoreConnectAllowedCheckoutRoute
  '/store/dm-offer/checkout': typeof AuthOnlyHeaderStoreDmOfferAllowedCheckoutRoute
  '/store/methods-offer/checkout': typeof AuthOnlyHeaderStoreMethodsOfferAllowedCheckoutRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/(redirects)/checkout': typeof redirectsCheckoutRoute
  '/(redirects)/fleet': typeof redirectsFleetRouteWithChildren
  '/(redirects)/settings': typeof redirectsSettingsRoute
  '/_auth/_layout': typeof AuthLayoutRouteWithChildren
  '/_auth/_only-header': typeof AuthOnlyHeaderRouteWithChildren
  '/_auth/enterprise': typeof AuthEnterpriseRouteWithChildren
  '/_public/_layout': typeof PublicLayoutRouteWithChildren
  '/_public/access-denied': typeof PublicAccessDeniedRoute
  '/_public/authentication-error': typeof PublicAuthenticationErrorRoute
  '/_public/connect-for-business': typeof PublicConnectForBusinessRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/logout': typeof PublicLogoutRoute
  '/_public/method-not-supported': typeof PublicMethodNotSupportedRoute
  '/_public/saml-error': typeof PublicSamlErrorRoute
  '/_public/test-data': typeof PublicTestDataRoute
  '/(redirects)/fleet/members': typeof redirectsFleetMembersRoute
  '/_auth/(no-layout)/verified': typeof AuthnoLayoutVerifiedRoute
  '/_auth/_layout/account': typeof AuthLayoutAccountRouteWithChildren
  '/_auth/_layout/data-access-consent': typeof AuthLayoutDataAccessConsentRoute
  '/_auth/_layout/device': typeof AuthLayoutDeviceRouteWithChildren
  '/_auth/_layout/integrations': typeof AuthLayoutIntegrationsRouteWithChildren
  '/_auth/_layout/myfiles': typeof AuthLayoutMyfilesRouteWithChildren
  '/_auth/_layout/subscriptions': typeof AuthLayoutSubscriptionsRouteWithChildren
  '/_auth/_only-header/store': typeof AuthOnlyHeaderStoreRouteWithChildren
  '/_auth/_only-header/verify-new-email': typeof AuthOnlyHeaderVerifyNewEmailRoute
  '/_auth/enterprise/_with-org': typeof AuthEnterpriseWithOrgRouteWithChildren
  '/_auth/enterprise/enroll': typeof AuthEnterpriseEnrollRouteWithChildren
  '/_auth/enterprise/link': typeof AuthEnterpriseLinkRoute
  '/_auth/pair/app': typeof AuthPairAppRoute
  '/_public/downloads/mobile-app': typeof PublicDownloadsMobileAppRoute
  '/_public/landing-page/device-setup': typeof PublicLandingPageDeviceSetupRoute
  '/_auth/_layout/': typeof AuthLayoutIndexRoute
  '/_auth/enterprise/': typeof AuthEnterpriseIndexRoute
  '/_auth/(no-layout)/account/delete': typeof AuthnoLayoutAccountDeleteRouteWithChildren
  '/_auth/_layout/account/delete': typeof AuthLayoutAccountDeleteRouteWithChildren
  '/_auth/_layout/device/browser': typeof AuthLayoutDeviceBrowserRoute
  '/_auth/_layout/device/desktop': typeof AuthLayoutDeviceDesktopRoute
  '/_auth/_layout/device/mobile': typeof AuthLayoutDeviceMobileRoute
  '/_auth/_layout/device/remarkable': typeof AuthLayoutDeviceRemarkableRoute
  '/_auth/_layout/integrations/callback': typeof AuthLayoutIntegrationsCallbackRoute
  '/_auth/_layout/invitation/seat': typeof AuthLayoutInvitationSeatRoute
  '/_auth/_layout/subscriptions/members': typeof AuthLayoutSubscriptionsMembersRoute
  '/_auth/_layout/subscriptions/payment': typeof AuthLayoutSubscriptionsPaymentRoute
  '/_auth/_layout/subscriptions/plan': typeof AuthLayoutSubscriptionsPlanRoute
  '/_auth/_only-header/store/checkout': typeof AuthOnlyHeaderStoreCheckoutRoute
  '/_auth/_only-header/store/checkout-return': typeof AuthOnlyHeaderStoreCheckoutReturnRoute
  '/_auth/_only-header/store/confirmation': typeof AuthOnlyHeaderStoreConfirmationRoute
  '/_auth/_only-header/store/connect-offer': typeof AuthOnlyHeaderStoreConnectOfferRouteWithChildren
  '/_auth/_only-header/store/dm-offer': typeof AuthOnlyHeaderStoreDmOfferRouteWithChildren
  '/_auth/_only-header/store/methods-offer': typeof AuthOnlyHeaderStoreMethodsOfferRouteWithChildren
  '/_auth/enterprise/_with-org/_layout': typeof AuthEnterpriseWithOrgLayoutRouteWithChildren
  '/_auth/enterprise/enroll/confirm-setup': typeof AuthEnterpriseEnrollConfirmSetupRoute
  '/_auth/enterprise/enroll/create-organization': typeof AuthEnterpriseEnrollCreateOrganizationRoute
  '/_auth/enterprise/enroll/setup': typeof AuthEnterpriseEnrollSetupRoute
  '/_auth/enterprise/enroll/setup-saml': typeof AuthEnterpriseEnrollSetupSamlRoute
  '/_auth/enterprise/enroll/verify-domain': typeof AuthEnterpriseEnrollVerifyDomainRoute
  '/_auth/enterprise/enroll/verify-saml': typeof AuthEnterpriseEnrollVerifySamlRoute
  '/_auth/_layout/myfiles/$': typeof AuthLayoutMyfilesSplatLazyRoute
  '/_auth/_layout/account/': typeof AuthLayoutAccountIndexRoute
  '/_auth/_layout/device/': typeof AuthLayoutDeviceIndexRoute
  '/_auth/_layout/integrations/': typeof AuthLayoutIntegrationsIndexRoute
  '/_auth/_layout/pair/': typeof AuthLayoutPairIndexRoute
  '/_auth/_layout/subscriptions/': typeof AuthLayoutSubscriptionsIndexRoute
  '/_auth/_only-header/store/': typeof AuthOnlyHeaderStoreIndexRoute
  '/_auth/enterprise/enroll/': typeof AuthEnterpriseEnrollIndexRoute
  '/_auth/_layout/account/delete/confirmation': typeof AuthLayoutAccountDeleteConfirmationRoute
  '/_auth/_layout/account/delete/landing': typeof AuthLayoutAccountDeleteLandingRoute
  '/_auth/_layout/account/migrate/success': typeof AuthLayoutAccountMigrateSuccessRoute
  '/_auth/_layout/device/apps/connect': typeof AuthLayoutDeviceAppsConnectRoute
  '/_auth/_layout/device/browser_/connect': typeof AuthLayoutDeviceBrowserConnectRoute
  '/_auth/_layout/device/desktop_/connect': typeof AuthLayoutDeviceDesktopConnectRoute
  '/_auth/_layout/device/mobile_/connect': typeof AuthLayoutDeviceMobileConnectRoute
  '/_auth/_layout/device/remarkable_/connect': typeof AuthLayoutDeviceRemarkableConnectRoute
  '/_auth/_only-header/store/connect-offer/_allowed': typeof AuthOnlyHeaderStoreConnectOfferAllowedRouteWithChildren
  '/_auth/_only-header/store/connect-offer/confirmation': typeof AuthOnlyHeaderStoreConnectOfferConfirmationRoute
  '/_auth/_only-header/store/connect-offer/download-apps': typeof AuthOnlyHeaderStoreConnectOfferDownloadAppsRoute
  '/_auth/_only-header/store/connect-offer/setup-complete': typeof AuthOnlyHeaderStoreConnectOfferSetupCompleteRoute
  '/_auth/_only-header/store/connect': typeof AuthOnlyHeaderStoreConnectRouteWithChildren
  '/_auth/_only-header/store/connect/_allowed': typeof AuthOnlyHeaderStoreConnectAllowedRouteWithChildren
  '/_auth/_only-header/store/connect/confirmation': typeof AuthOnlyHeaderStoreConnectConfirmationRoute
  '/_auth/_only-header/store/dm-offer/_allowed': typeof AuthOnlyHeaderStoreDmOfferAllowedRouteWithChildren
  '/_auth/_only-header/store/dm-offer/confirmation': typeof AuthOnlyHeaderStoreDmOfferConfirmationRoute
  '/_auth/_only-header/store/dm-offer/setup-complete': typeof AuthOnlyHeaderStoreDmOfferSetupCompleteRoute
  '/_auth/_only-header/store/methods-offer/_allowed': typeof AuthOnlyHeaderStoreMethodsOfferAllowedRouteWithChildren
  '/_auth/_only-header/store/methods-offer/confirmation': typeof AuthOnlyHeaderStoreMethodsOfferConfirmationRoute
  '/_auth/_only-header/store/methods-offer/download-apps': typeof AuthOnlyHeaderStoreMethodsOfferDownloadAppsRoute
  '/_auth/_only-header/store/methods-offer/setup-complete': typeof AuthOnlyHeaderStoreMethodsOfferSetupCompleteRoute
  '/_auth/enterprise/_with-org/_layout/billing': typeof AuthEnterpriseWithOrgLayoutBillingRoute
  '/_auth/enterprise/_with-org/_layout/devices': typeof AuthEnterpriseWithOrgLayoutDevicesRoute
  '/_auth/enterprise/_with-org/_layout/domains': typeof AuthEnterpriseWithOrgLayoutDomainsRoute
  '/_auth/enterprise/_with-org/_layout/members': typeof AuthEnterpriseWithOrgLayoutMembersRoute
  '/_auth/enterprise/_with-org/_layout/plan': typeof AuthEnterpriseWithOrgLayoutPlanRoute
  '/_auth/enterprise/_with-org/_layout/policies': typeof AuthEnterpriseWithOrgLayoutPoliciesRoute
  '/_auth/enterprise/_with-org/_layout/settings': typeof AuthEnterpriseWithOrgLayoutSettingsRoute
  '/_public/_layout/account/migrate/saml': typeof PublicLayoutAccountMigrateSamlRoute
  '/_auth/_layout/account/delete/': typeof AuthLayoutAccountDeleteIndexRoute
  '/_auth/_layout/account/migrate/': typeof AuthLayoutAccountMigrateIndexRoute
  '/_auth/_layout/device/apps/': typeof AuthLayoutDeviceAppsIndexRoute
  '/_auth/enterprise/_with-org/offboarding/': typeof AuthEnterpriseWithOrgOffboardingIndexRoute
  '/_auth/(no-layout)/account/delete/confirmation/app': typeof AuthnoLayoutAccountDeleteConfirmationAppRoute
  '/_auth/(no-layout)/account/delete/landing/app': typeof AuthnoLayoutAccountDeleteLandingAppRoute
  '/_auth/_only-header/store/connect-offer/_allowed/checkout': typeof AuthOnlyHeaderStoreConnectOfferAllowedCheckoutRoute
  '/_auth/_only-header/store/connect/_allowed/checkout': typeof AuthOnlyHeaderStoreConnectAllowedCheckoutRoute
  '/_auth/_only-header/store/dm-offer/_allowed/checkout': typeof AuthOnlyHeaderStoreDmOfferAllowedCheckoutRoute
  '/_auth/_only-header/store/methods-offer/_allowed/checkout': typeof AuthOnlyHeaderStoreMethodsOfferAllowedCheckoutRoute
  '/_auth/_only-header/store/connect-offer/_allowed/': typeof AuthOnlyHeaderStoreConnectOfferAllowedIndexRoute
  '/_auth/_only-header/store/connect/_allowed/': typeof AuthOnlyHeaderStoreConnectAllowedIndexRoute
  '/_auth/_only-header/store/dm-offer/_allowed/': typeof AuthOnlyHeaderStoreDmOfferAllowedIndexRoute
  '/_auth/_only-header/store/methods-offer/_allowed/': typeof AuthOnlyHeaderStoreMethodsOfferAllowedIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/checkout'
    | '/fleet'
    | '/settings'
    | '/enterprise'
    | '/access-denied'
    | '/authentication-error'
    | '/connect-for-business'
    | '/login'
    | '/logout'
    | '/method-not-supported'
    | '/saml-error'
    | '/test-data'
    | '/fleet/members'
    | '/verified'
    | '/account'
    | '/data-access-consent'
    | '/device'
    | '/integrations'
    | '/myfiles'
    | '/subscriptions'
    | '/store'
    | '/verify-new-email'
    | '/enterprise/enroll'
    | '/enterprise/link'
    | '/pair/app'
    | '/downloads/mobile-app'
    | '/landing-page/device-setup'
    | '/'
    | '/enterprise/'
    | '/account/delete'
    | '/device/browser'
    | '/device/desktop'
    | '/device/mobile'
    | '/device/remarkable'
    | '/integrations/callback'
    | '/invitation/seat'
    | '/subscriptions/members'
    | '/subscriptions/payment'
    | '/subscriptions/plan'
    | '/store/checkout'
    | '/store/checkout-return'
    | '/store/confirmation'
    | '/store/connect-offer'
    | '/store/dm-offer'
    | '/store/methods-offer'
    | '/enterprise/enroll/confirm-setup'
    | '/enterprise/enroll/create-organization'
    | '/enterprise/enroll/setup'
    | '/enterprise/enroll/setup-saml'
    | '/enterprise/enroll/verify-domain'
    | '/enterprise/enroll/verify-saml'
    | '/myfiles/$'
    | '/account/'
    | '/device/'
    | '/integrations/'
    | '/pair'
    | '/subscriptions/'
    | '/store/'
    | '/enterprise/enroll/'
    | '/account/delete/confirmation'
    | '/account/delete/landing'
    | '/account/migrate/success'
    | '/device/apps/connect'
    | '/device/browser/connect'
    | '/device/desktop/connect'
    | '/device/mobile/connect'
    | '/device/remarkable/connect'
    | '/store/connect-offer/confirmation'
    | '/store/connect-offer/download-apps'
    | '/store/connect-offer/setup-complete'
    | '/store/connect'
    | '/store/connect/confirmation'
    | '/store/dm-offer/confirmation'
    | '/store/dm-offer/setup-complete'
    | '/store/methods-offer/confirmation'
    | '/store/methods-offer/download-apps'
    | '/store/methods-offer/setup-complete'
    | '/enterprise/billing'
    | '/enterprise/devices'
    | '/enterprise/domains'
    | '/enterprise/members'
    | '/enterprise/plan'
    | '/enterprise/policies'
    | '/enterprise/settings'
    | '/account/migrate/saml'
    | '/account/delete/'
    | '/account/migrate'
    | '/device/apps'
    | '/enterprise/offboarding'
    | '/account/delete/confirmation/app'
    | '/account/delete/landing/app'
    | '/store/connect-offer/checkout'
    | '/store/connect/checkout'
    | '/store/dm-offer/checkout'
    | '/store/methods-offer/checkout'
    | '/store/connect-offer/'
    | '/store/connect/'
    | '/store/dm-offer/'
    | '/store/methods-offer/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/checkout'
    | '/fleet'
    | '/settings'
    | '/access-denied'
    | '/authentication-error'
    | '/connect-for-business'
    | '/login'
    | '/logout'
    | '/method-not-supported'
    | '/saml-error'
    | '/test-data'
    | '/fleet/members'
    | '/verified'
    | '/data-access-consent'
    | '/myfiles'
    | '/verify-new-email'
    | '/enterprise'
    | '/enterprise/link'
    | '/pair/app'
    | '/downloads/mobile-app'
    | '/landing-page/device-setup'
    | '/'
    | '/account/delete'
    | '/device/browser'
    | '/device/desktop'
    | '/device/mobile'
    | '/device/remarkable'
    | '/integrations/callback'
    | '/invitation/seat'
    | '/subscriptions/members'
    | '/subscriptions/payment'
    | '/subscriptions/plan'
    | '/store/checkout'
    | '/store/checkout-return'
    | '/store/confirmation'
    | '/store/connect-offer'
    | '/store/dm-offer'
    | '/store/methods-offer'
    | '/enterprise/enroll/confirm-setup'
    | '/enterprise/enroll/create-organization'
    | '/enterprise/enroll/setup'
    | '/enterprise/enroll/setup-saml'
    | '/enterprise/enroll/verify-domain'
    | '/enterprise/enroll/verify-saml'
    | '/myfiles/$'
    | '/account'
    | '/device'
    | '/integrations'
    | '/pair'
    | '/subscriptions'
    | '/store'
    | '/enterprise/enroll'
    | '/account/delete/confirmation'
    | '/account/delete/landing'
    | '/account/migrate/success'
    | '/device/apps/connect'
    | '/device/browser/connect'
    | '/device/desktop/connect'
    | '/device/mobile/connect'
    | '/device/remarkable/connect'
    | '/store/connect-offer/confirmation'
    | '/store/connect-offer/download-apps'
    | '/store/connect-offer/setup-complete'
    | '/store/connect'
    | '/store/connect/confirmation'
    | '/store/dm-offer/confirmation'
    | '/store/dm-offer/setup-complete'
    | '/store/methods-offer/confirmation'
    | '/store/methods-offer/download-apps'
    | '/store/methods-offer/setup-complete'
    | '/enterprise/billing'
    | '/enterprise/devices'
    | '/enterprise/domains'
    | '/enterprise/members'
    | '/enterprise/plan'
    | '/enterprise/policies'
    | '/enterprise/settings'
    | '/account/migrate/saml'
    | '/account/migrate'
    | '/device/apps'
    | '/enterprise/offboarding'
    | '/account/delete/confirmation/app'
    | '/account/delete/landing/app'
    | '/store/connect-offer/checkout'
    | '/store/connect/checkout'
    | '/store/dm-offer/checkout'
    | '/store/methods-offer/checkout'
  id:
    | '__root__'
    | '/_auth'
    | '/_public'
    | '/(redirects)/checkout'
    | '/(redirects)/fleet'
    | '/(redirects)/settings'
    | '/_auth/_layout'
    | '/_auth/_only-header'
    | '/_auth/enterprise'
    | '/_public/_layout'
    | '/_public/access-denied'
    | '/_public/authentication-error'
    | '/_public/connect-for-business'
    | '/_public/login'
    | '/_public/logout'
    | '/_public/method-not-supported'
    | '/_public/saml-error'
    | '/_public/test-data'
    | '/(redirects)/fleet/members'
    | '/_auth/(no-layout)/verified'
    | '/_auth/_layout/account'
    | '/_auth/_layout/data-access-consent'
    | '/_auth/_layout/device'
    | '/_auth/_layout/integrations'
    | '/_auth/_layout/myfiles'
    | '/_auth/_layout/subscriptions'
    | '/_auth/_only-header/store'
    | '/_auth/_only-header/verify-new-email'
    | '/_auth/enterprise/_with-org'
    | '/_auth/enterprise/enroll'
    | '/_auth/enterprise/link'
    | '/_auth/pair/app'
    | '/_public/downloads/mobile-app'
    | '/_public/landing-page/device-setup'
    | '/_auth/_layout/'
    | '/_auth/enterprise/'
    | '/_auth/(no-layout)/account/delete'
    | '/_auth/_layout/account/delete'
    | '/_auth/_layout/device/browser'
    | '/_auth/_layout/device/desktop'
    | '/_auth/_layout/device/mobile'
    | '/_auth/_layout/device/remarkable'
    | '/_auth/_layout/integrations/callback'
    | '/_auth/_layout/invitation/seat'
    | '/_auth/_layout/subscriptions/members'
    | '/_auth/_layout/subscriptions/payment'
    | '/_auth/_layout/subscriptions/plan'
    | '/_auth/_only-header/store/checkout'
    | '/_auth/_only-header/store/checkout-return'
    | '/_auth/_only-header/store/confirmation'
    | '/_auth/_only-header/store/connect-offer'
    | '/_auth/_only-header/store/dm-offer'
    | '/_auth/_only-header/store/methods-offer'
    | '/_auth/enterprise/_with-org/_layout'
    | '/_auth/enterprise/enroll/confirm-setup'
    | '/_auth/enterprise/enroll/create-organization'
    | '/_auth/enterprise/enroll/setup'
    | '/_auth/enterprise/enroll/setup-saml'
    | '/_auth/enterprise/enroll/verify-domain'
    | '/_auth/enterprise/enroll/verify-saml'
    | '/_auth/_layout/myfiles/$'
    | '/_auth/_layout/account/'
    | '/_auth/_layout/device/'
    | '/_auth/_layout/integrations/'
    | '/_auth/_layout/pair/'
    | '/_auth/_layout/subscriptions/'
    | '/_auth/_only-header/store/'
    | '/_auth/enterprise/enroll/'
    | '/_auth/_layout/account/delete/confirmation'
    | '/_auth/_layout/account/delete/landing'
    | '/_auth/_layout/account/migrate/success'
    | '/_auth/_layout/device/apps/connect'
    | '/_auth/_layout/device/browser_/connect'
    | '/_auth/_layout/device/desktop_/connect'
    | '/_auth/_layout/device/mobile_/connect'
    | '/_auth/_layout/device/remarkable_/connect'
    | '/_auth/_only-header/store/connect-offer/_allowed'
    | '/_auth/_only-header/store/connect-offer/confirmation'
    | '/_auth/_only-header/store/connect-offer/download-apps'
    | '/_auth/_only-header/store/connect-offer/setup-complete'
    | '/_auth/_only-header/store/connect'
    | '/_auth/_only-header/store/connect/_allowed'
    | '/_auth/_only-header/store/connect/confirmation'
    | '/_auth/_only-header/store/dm-offer/_allowed'
    | '/_auth/_only-header/store/dm-offer/confirmation'
    | '/_auth/_only-header/store/dm-offer/setup-complete'
    | '/_auth/_only-header/store/methods-offer/_allowed'
    | '/_auth/_only-header/store/methods-offer/confirmation'
    | '/_auth/_only-header/store/methods-offer/download-apps'
    | '/_auth/_only-header/store/methods-offer/setup-complete'
    | '/_auth/enterprise/_with-org/_layout/billing'
    | '/_auth/enterprise/_with-org/_layout/devices'
    | '/_auth/enterprise/_with-org/_layout/domains'
    | '/_auth/enterprise/_with-org/_layout/members'
    | '/_auth/enterprise/_with-org/_layout/plan'
    | '/_auth/enterprise/_with-org/_layout/policies'
    | '/_auth/enterprise/_with-org/_layout/settings'
    | '/_public/_layout/account/migrate/saml'
    | '/_auth/_layout/account/delete/'
    | '/_auth/_layout/account/migrate/'
    | '/_auth/_layout/device/apps/'
    | '/_auth/enterprise/_with-org/offboarding/'
    | '/_auth/(no-layout)/account/delete/confirmation/app'
    | '/_auth/(no-layout)/account/delete/landing/app'
    | '/_auth/_only-header/store/connect-offer/_allowed/checkout'
    | '/_auth/_only-header/store/connect/_allowed/checkout'
    | '/_auth/_only-header/store/dm-offer/_allowed/checkout'
    | '/_auth/_only-header/store/methods-offer/_allowed/checkout'
    | '/_auth/_only-header/store/connect-offer/_allowed/'
    | '/_auth/_only-header/store/connect/_allowed/'
    | '/_auth/_only-header/store/dm-offer/_allowed/'
    | '/_auth/_only-header/store/methods-offer/_allowed/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  redirectsCheckoutRoute: typeof redirectsCheckoutRoute
  redirectsFleetRoute: typeof redirectsFleetRouteWithChildren
  redirectsSettingsRoute: typeof redirectsSettingsRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  redirectsCheckoutRoute: redirectsCheckoutRoute,
  redirectsFleetRoute: redirectsFleetRouteWithChildren,
  redirectsSettingsRoute: redirectsSettingsRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_auth",
        "/_public",
        "/(redirects)/checkout",
        "/(redirects)/fleet",
        "/(redirects)/settings"
      ]
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/_layout",
        "/_auth/_only-header",
        "/_auth/enterprise",
        "/_auth/(no-layout)/verified",
        "/_auth/pair/app",
        "/_auth/(no-layout)/account/delete"
      ]
    },
    "/_public": {
      "filePath": "_public.tsx",
      "children": [
        "/_public/_layout",
        "/_public/access-denied",
        "/_public/authentication-error",
        "/_public/connect-for-business",
        "/_public/login",
        "/_public/logout",
        "/_public/method-not-supported",
        "/_public/saml-error",
        "/_public/test-data",
        "/_public/downloads/mobile-app",
        "/_public/landing-page/device-setup"
      ]
    },
    "/(redirects)/checkout": {
      "filePath": "(redirects)/checkout.tsx"
    },
    "/(redirects)/fleet": {
      "filePath": "(redirects)/fleet.tsx",
      "children": [
        "/(redirects)/fleet/members"
      ]
    },
    "/(redirects)/settings": {
      "filePath": "(redirects)/settings.tsx"
    },
    "/_auth/_layout": {
      "filePath": "_auth/_layout.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/_layout/account",
        "/_auth/_layout/data-access-consent",
        "/_auth/_layout/device",
        "/_auth/_layout/integrations",
        "/_auth/_layout/myfiles",
        "/_auth/_layout/subscriptions",
        "/_auth/_layout/",
        "/_auth/_layout/invitation/seat",
        "/_auth/_layout/pair/"
      ]
    },
    "/_auth/_only-header": {
      "filePath": "_auth/_only-header.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/_only-header/store",
        "/_auth/_only-header/verify-new-email"
      ]
    },
    "/_auth/enterprise": {
      "filePath": "_auth/enterprise.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/enterprise/_with-org",
        "/_auth/enterprise/enroll",
        "/_auth/enterprise/link",
        "/_auth/enterprise/"
      ]
    },
    "/_public/_layout": {
      "filePath": "_public/_layout.tsx",
      "parent": "/_public",
      "children": [
        "/_public/_layout/account/migrate/saml"
      ]
    },
    "/_public/access-denied": {
      "filePath": "_public/access-denied.tsx",
      "parent": "/_public"
    },
    "/_public/authentication-error": {
      "filePath": "_public/authentication-error.tsx",
      "parent": "/_public"
    },
    "/_public/connect-for-business": {
      "filePath": "_public/connect-for-business.tsx",
      "parent": "/_public"
    },
    "/_public/login": {
      "filePath": "_public/login.tsx",
      "parent": "/_public"
    },
    "/_public/logout": {
      "filePath": "_public/logout.tsx",
      "parent": "/_public"
    },
    "/_public/method-not-supported": {
      "filePath": "_public/method-not-supported.tsx",
      "parent": "/_public"
    },
    "/_public/saml-error": {
      "filePath": "_public/saml-error.tsx",
      "parent": "/_public"
    },
    "/_public/test-data": {
      "filePath": "_public/test-data.tsx",
      "parent": "/_public"
    },
    "/(redirects)/fleet/members": {
      "filePath": "(redirects)/fleet.members.tsx",
      "parent": "/(redirects)/fleet"
    },
    "/_auth/(no-layout)/verified": {
      "filePath": "_auth/(no-layout)/verified.tsx",
      "parent": "/_auth"
    },
    "/_auth/_layout/account": {
      "filePath": "_auth/_layout/account.tsx",
      "parent": "/_auth/_layout",
      "children": [
        "/_auth/_layout/account/delete",
        "/_auth/_layout/account/",
        "/_auth/_layout/account/migrate/success",
        "/_auth/_layout/account/migrate/"
      ]
    },
    "/_auth/_layout/data-access-consent": {
      "filePath": "_auth/_layout/data-access-consent.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/device": {
      "filePath": "_auth/_layout/device.tsx",
      "parent": "/_auth/_layout",
      "children": [
        "/_auth/_layout/device/browser",
        "/_auth/_layout/device/desktop",
        "/_auth/_layout/device/mobile",
        "/_auth/_layout/device/remarkable",
        "/_auth/_layout/device/",
        "/_auth/_layout/device/apps/connect",
        "/_auth/_layout/device/browser_/connect",
        "/_auth/_layout/device/desktop_/connect",
        "/_auth/_layout/device/mobile_/connect",
        "/_auth/_layout/device/remarkable_/connect",
        "/_auth/_layout/device/apps/"
      ]
    },
    "/_auth/_layout/integrations": {
      "filePath": "_auth/_layout/integrations.tsx",
      "parent": "/_auth/_layout",
      "children": [
        "/_auth/_layout/integrations/callback",
        "/_auth/_layout/integrations/"
      ]
    },
    "/_auth/_layout/myfiles": {
      "filePath": "_auth/_layout/myfiles.tsx",
      "parent": "/_auth/_layout",
      "children": [
        "/_auth/_layout/myfiles/$"
      ]
    },
    "/_auth/_layout/subscriptions": {
      "filePath": "_auth/_layout/subscriptions.tsx",
      "parent": "/_auth/_layout",
      "children": [
        "/_auth/_layout/subscriptions/members",
        "/_auth/_layout/subscriptions/payment",
        "/_auth/_layout/subscriptions/plan",
        "/_auth/_layout/subscriptions/"
      ]
    },
    "/_auth/_only-header/store": {
      "filePath": "_auth/_only-header/store.tsx",
      "parent": "/_auth/_only-header",
      "children": [
        "/_auth/_only-header/store/checkout",
        "/_auth/_only-header/store/checkout-return",
        "/_auth/_only-header/store/confirmation",
        "/_auth/_only-header/store/connect-offer",
        "/_auth/_only-header/store/dm-offer",
        "/_auth/_only-header/store/methods-offer",
        "/_auth/_only-header/store/",
        "/_auth/_only-header/store/connect"
      ]
    },
    "/_auth/_only-header/verify-new-email": {
      "filePath": "_auth/_only-header/verify-new-email.tsx",
      "parent": "/_auth/_only-header"
    },
    "/_auth/enterprise/_with-org": {
      "filePath": "_auth/enterprise/_with-org.tsx",
      "parent": "/_auth/enterprise",
      "children": [
        "/_auth/enterprise/_with-org/_layout",
        "/_auth/enterprise/_with-org/offboarding/"
      ]
    },
    "/_auth/enterprise/enroll": {
      "filePath": "_auth/enterprise/enroll.tsx",
      "parent": "/_auth/enterprise",
      "children": [
        "/_auth/enterprise/enroll/confirm-setup",
        "/_auth/enterprise/enroll/create-organization",
        "/_auth/enterprise/enroll/setup",
        "/_auth/enterprise/enroll/setup-saml",
        "/_auth/enterprise/enroll/verify-domain",
        "/_auth/enterprise/enroll/verify-saml",
        "/_auth/enterprise/enroll/"
      ]
    },
    "/_auth/enterprise/link": {
      "filePath": "_auth/enterprise/link.tsx",
      "parent": "/_auth/enterprise"
    },
    "/_auth/pair/app": {
      "filePath": "_auth/pair.app.tsx",
      "parent": "/_auth"
    },
    "/_public/downloads/mobile-app": {
      "filePath": "_public/downloads.mobile-app.tsx",
      "parent": "/_public"
    },
    "/_public/landing-page/device-setup": {
      "filePath": "_public/landing-page.device-setup.tsx",
      "parent": "/_public"
    },
    "/_auth/_layout/": {
      "filePath": "_auth/_layout/index.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/enterprise/": {
      "filePath": "_auth/enterprise/index.tsx",
      "parent": "/_auth/enterprise"
    },
    "/_auth/(no-layout)/account/delete": {
      "filePath": "_auth/(no-layout)/account/delete.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/(no-layout)/account/delete/confirmation/app",
        "/_auth/(no-layout)/account/delete/landing/app"
      ]
    },
    "/_auth/_layout/account/delete": {
      "filePath": "_auth/_layout/account/delete.tsx",
      "parent": "/_auth/_layout/account",
      "children": [
        "/_auth/_layout/account/delete/confirmation",
        "/_auth/_layout/account/delete/landing",
        "/_auth/_layout/account/delete/"
      ]
    },
    "/_auth/_layout/device/browser": {
      "filePath": "_auth/_layout/device/browser.tsx",
      "parent": "/_auth/_layout/device"
    },
    "/_auth/_layout/device/desktop": {
      "filePath": "_auth/_layout/device/desktop.tsx",
      "parent": "/_auth/_layout/device"
    },
    "/_auth/_layout/device/mobile": {
      "filePath": "_auth/_layout/device/mobile.tsx",
      "parent": "/_auth/_layout/device"
    },
    "/_auth/_layout/device/remarkable": {
      "filePath": "_auth/_layout/device/remarkable.tsx",
      "parent": "/_auth/_layout/device"
    },
    "/_auth/_layout/integrations/callback": {
      "filePath": "_auth/_layout/integrations.callback.tsx",
      "parent": "/_auth/_layout/integrations"
    },
    "/_auth/_layout/invitation/seat": {
      "filePath": "_auth/_layout/invitation/seat.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/subscriptions/members": {
      "filePath": "_auth/_layout/subscriptions/members.tsx",
      "parent": "/_auth/_layout/subscriptions"
    },
    "/_auth/_layout/subscriptions/payment": {
      "filePath": "_auth/_layout/subscriptions/payment.tsx",
      "parent": "/_auth/_layout/subscriptions"
    },
    "/_auth/_layout/subscriptions/plan": {
      "filePath": "_auth/_layout/subscriptions/plan.tsx",
      "parent": "/_auth/_layout/subscriptions"
    },
    "/_auth/_only-header/store/checkout": {
      "filePath": "_auth/_only-header/store/checkout.tsx",
      "parent": "/_auth/_only-header/store"
    },
    "/_auth/_only-header/store/checkout-return": {
      "filePath": "_auth/_only-header/store/checkout-return.tsx",
      "parent": "/_auth/_only-header/store"
    },
    "/_auth/_only-header/store/confirmation": {
      "filePath": "_auth/_only-header/store/confirmation.tsx",
      "parent": "/_auth/_only-header/store"
    },
    "/_auth/_only-header/store/connect-offer": {
      "filePath": "_auth/_only-header/store/connect-offer.tsx",
      "parent": "/_auth/_only-header/store",
      "children": [
        "/_auth/_only-header/store/connect-offer/_allowed",
        "/_auth/_only-header/store/connect-offer/confirmation",
        "/_auth/_only-header/store/connect-offer/download-apps",
        "/_auth/_only-header/store/connect-offer/setup-complete"
      ]
    },
    "/_auth/_only-header/store/dm-offer": {
      "filePath": "_auth/_only-header/store/dm-offer.tsx",
      "parent": "/_auth/_only-header/store",
      "children": [
        "/_auth/_only-header/store/dm-offer/_allowed",
        "/_auth/_only-header/store/dm-offer/confirmation",
        "/_auth/_only-header/store/dm-offer/setup-complete"
      ]
    },
    "/_auth/_only-header/store/methods-offer": {
      "filePath": "_auth/_only-header/store/methods-offer.tsx",
      "parent": "/_auth/_only-header/store",
      "children": [
        "/_auth/_only-header/store/methods-offer/_allowed",
        "/_auth/_only-header/store/methods-offer/confirmation",
        "/_auth/_only-header/store/methods-offer/download-apps",
        "/_auth/_only-header/store/methods-offer/setup-complete"
      ]
    },
    "/_auth/enterprise/_with-org/_layout": {
      "filePath": "_auth/enterprise/_with-org/_layout.tsx",
      "parent": "/_auth/enterprise/_with-org",
      "children": [
        "/_auth/enterprise/_with-org/_layout/billing",
        "/_auth/enterprise/_with-org/_layout/devices",
        "/_auth/enterprise/_with-org/_layout/domains",
        "/_auth/enterprise/_with-org/_layout/members",
        "/_auth/enterprise/_with-org/_layout/plan",
        "/_auth/enterprise/_with-org/_layout/policies",
        "/_auth/enterprise/_with-org/_layout/settings"
      ]
    },
    "/_auth/enterprise/enroll/confirm-setup": {
      "filePath": "_auth/enterprise/enroll/confirm-setup.tsx",
      "parent": "/_auth/enterprise/enroll"
    },
    "/_auth/enterprise/enroll/create-organization": {
      "filePath": "_auth/enterprise/enroll/create-organization.tsx",
      "parent": "/_auth/enterprise/enroll"
    },
    "/_auth/enterprise/enroll/setup": {
      "filePath": "_auth/enterprise/enroll/setup.tsx",
      "parent": "/_auth/enterprise/enroll"
    },
    "/_auth/enterprise/enroll/setup-saml": {
      "filePath": "_auth/enterprise/enroll/setup-saml.tsx",
      "parent": "/_auth/enterprise/enroll"
    },
    "/_auth/enterprise/enroll/verify-domain": {
      "filePath": "_auth/enterprise/enroll/verify-domain.tsx",
      "parent": "/_auth/enterprise/enroll"
    },
    "/_auth/enterprise/enroll/verify-saml": {
      "filePath": "_auth/enterprise/enroll/verify-saml.tsx",
      "parent": "/_auth/enterprise/enroll"
    },
    "/_auth/_layout/myfiles/$": {
      "filePath": "_auth/_layout/myfiles.$.lazy.tsx",
      "parent": "/_auth/_layout/myfiles"
    },
    "/_auth/_layout/account/": {
      "filePath": "_auth/_layout/account/index.tsx",
      "parent": "/_auth/_layout/account"
    },
    "/_auth/_layout/device/": {
      "filePath": "_auth/_layout/device/index.tsx",
      "parent": "/_auth/_layout/device"
    },
    "/_auth/_layout/integrations/": {
      "filePath": "_auth/_layout/integrations.index.tsx",
      "parent": "/_auth/_layout/integrations"
    },
    "/_auth/_layout/pair/": {
      "filePath": "_auth/_layout/pair/index.tsx",
      "parent": "/_auth/_layout"
    },
    "/_auth/_layout/subscriptions/": {
      "filePath": "_auth/_layout/subscriptions/index.tsx",
      "parent": "/_auth/_layout/subscriptions"
    },
    "/_auth/_only-header/store/": {
      "filePath": "_auth/_only-header/store/index.tsx",
      "parent": "/_auth/_only-header/store"
    },
    "/_auth/enterprise/enroll/": {
      "filePath": "_auth/enterprise/enroll/index.tsx",
      "parent": "/_auth/enterprise/enroll"
    },
    "/_auth/_layout/account/delete/confirmation": {
      "filePath": "_auth/_layout/account/delete.confirmation.tsx",
      "parent": "/_auth/_layout/account/delete"
    },
    "/_auth/_layout/account/delete/landing": {
      "filePath": "_auth/_layout/account/delete.landing.tsx",
      "parent": "/_auth/_layout/account/delete"
    },
    "/_auth/_layout/account/migrate/success": {
      "filePath": "_auth/_layout/account/migrate.success.tsx",
      "parent": "/_auth/_layout/account"
    },
    "/_auth/_layout/device/apps/connect": {
      "filePath": "_auth/_layout/device/apps/connect.tsx",
      "parent": "/_auth/_layout/device"
    },
    "/_auth/_layout/device/browser_/connect": {
      "filePath": "_auth/_layout/device/browser_.connect.tsx",
      "parent": "/_auth/_layout/device"
    },
    "/_auth/_layout/device/desktop_/connect": {
      "filePath": "_auth/_layout/device/desktop_.connect.tsx",
      "parent": "/_auth/_layout/device"
    },
    "/_auth/_layout/device/mobile_/connect": {
      "filePath": "_auth/_layout/device/mobile_.connect.tsx",
      "parent": "/_auth/_layout/device"
    },
    "/_auth/_layout/device/remarkable_/connect": {
      "filePath": "_auth/_layout/device/remarkable_.connect.tsx",
      "parent": "/_auth/_layout/device"
    },
    "/_auth/_only-header/store/connect-offer/_allowed": {
      "filePath": "_auth/_only-header/store/connect-offer._allowed.tsx",
      "parent": "/_auth/_only-header/store/connect-offer",
      "children": [
        "/_auth/_only-header/store/connect-offer/_allowed/checkout",
        "/_auth/_only-header/store/connect-offer/_allowed/"
      ]
    },
    "/_auth/_only-header/store/connect-offer/confirmation": {
      "filePath": "_auth/_only-header/store/connect-offer.confirmation.tsx",
      "parent": "/_auth/_only-header/store/connect-offer"
    },
    "/_auth/_only-header/store/connect-offer/download-apps": {
      "filePath": "_auth/_only-header/store/connect-offer.download-apps.tsx",
      "parent": "/_auth/_only-header/store/connect-offer"
    },
    "/_auth/_only-header/store/connect-offer/setup-complete": {
      "filePath": "_auth/_only-header/store/connect-offer.setup-complete.tsx",
      "parent": "/_auth/_only-header/store/connect-offer"
    },
    "/_auth/_only-header/store/connect": {
      "filePath": "_auth/_only-header/store",
      "parent": "/_auth/_only-header/store",
      "children": [
        "/_auth/_only-header/store/connect/_allowed",
        "/_auth/_only-header/store/connect/confirmation"
      ]
    },
    "/_auth/_only-header/store/connect/_allowed": {
      "filePath": "_auth/_only-header/store/connect._allowed.tsx",
      "parent": "/_auth/_only-header/store/connect",
      "children": [
        "/_auth/_only-header/store/connect/_allowed/checkout",
        "/_auth/_only-header/store/connect/_allowed/"
      ]
    },
    "/_auth/_only-header/store/connect/confirmation": {
      "filePath": "_auth/_only-header/store/connect.confirmation.tsx",
      "parent": "/_auth/_only-header/store/connect"
    },
    "/_auth/_only-header/store/dm-offer/_allowed": {
      "filePath": "_auth/_only-header/store/dm-offer._allowed.tsx",
      "parent": "/_auth/_only-header/store/dm-offer",
      "children": [
        "/_auth/_only-header/store/dm-offer/_allowed/checkout",
        "/_auth/_only-header/store/dm-offer/_allowed/"
      ]
    },
    "/_auth/_only-header/store/dm-offer/confirmation": {
      "filePath": "_auth/_only-header/store/dm-offer.confirmation.tsx",
      "parent": "/_auth/_only-header/store/dm-offer"
    },
    "/_auth/_only-header/store/dm-offer/setup-complete": {
      "filePath": "_auth/_only-header/store/dm-offer.setup-complete.tsx",
      "parent": "/_auth/_only-header/store/dm-offer"
    },
    "/_auth/_only-header/store/methods-offer/_allowed": {
      "filePath": "_auth/_only-header/store/methods-offer._allowed.tsx",
      "parent": "/_auth/_only-header/store/methods-offer",
      "children": [
        "/_auth/_only-header/store/methods-offer/_allowed/checkout",
        "/_auth/_only-header/store/methods-offer/_allowed/"
      ]
    },
    "/_auth/_only-header/store/methods-offer/confirmation": {
      "filePath": "_auth/_only-header/store/methods-offer.confirmation.tsx",
      "parent": "/_auth/_only-header/store/methods-offer"
    },
    "/_auth/_only-header/store/methods-offer/download-apps": {
      "filePath": "_auth/_only-header/store/methods-offer.download-apps.tsx",
      "parent": "/_auth/_only-header/store/methods-offer"
    },
    "/_auth/_only-header/store/methods-offer/setup-complete": {
      "filePath": "_auth/_only-header/store/methods-offer.setup-complete.tsx",
      "parent": "/_auth/_only-header/store/methods-offer"
    },
    "/_auth/enterprise/_with-org/_layout/billing": {
      "filePath": "_auth/enterprise/_with-org/_layout.billing.tsx",
      "parent": "/_auth/enterprise/_with-org/_layout"
    },
    "/_auth/enterprise/_with-org/_layout/devices": {
      "filePath": "_auth/enterprise/_with-org/_layout.devices.tsx",
      "parent": "/_auth/enterprise/_with-org/_layout"
    },
    "/_auth/enterprise/_with-org/_layout/domains": {
      "filePath": "_auth/enterprise/_with-org/_layout.domains.tsx",
      "parent": "/_auth/enterprise/_with-org/_layout"
    },
    "/_auth/enterprise/_with-org/_layout/members": {
      "filePath": "_auth/enterprise/_with-org/_layout.members.tsx",
      "parent": "/_auth/enterprise/_with-org/_layout"
    },
    "/_auth/enterprise/_with-org/_layout/plan": {
      "filePath": "_auth/enterprise/_with-org/_layout.plan.tsx",
      "parent": "/_auth/enterprise/_with-org/_layout"
    },
    "/_auth/enterprise/_with-org/_layout/policies": {
      "filePath": "_auth/enterprise/_with-org/_layout.policies.tsx",
      "parent": "/_auth/enterprise/_with-org/_layout"
    },
    "/_auth/enterprise/_with-org/_layout/settings": {
      "filePath": "_auth/enterprise/_with-org/_layout.settings.tsx",
      "parent": "/_auth/enterprise/_with-org/_layout"
    },
    "/_public/_layout/account/migrate/saml": {
      "filePath": "_public/_layout/account.migrate.saml.tsx",
      "parent": "/_public/_layout"
    },
    "/_auth/_layout/account/delete/": {
      "filePath": "_auth/_layout/account/delete.index.tsx",
      "parent": "/_auth/_layout/account/delete"
    },
    "/_auth/_layout/account/migrate/": {
      "filePath": "_auth/_layout/account/migrate.index.tsx",
      "parent": "/_auth/_layout/account"
    },
    "/_auth/_layout/device/apps/": {
      "filePath": "_auth/_layout/device/apps/index.tsx",
      "parent": "/_auth/_layout/device"
    },
    "/_auth/enterprise/_with-org/offboarding/": {
      "filePath": "_auth/enterprise/_with-org/offboarding.index.tsx",
      "parent": "/_auth/enterprise/_with-org"
    },
    "/_auth/(no-layout)/account/delete/confirmation/app": {
      "filePath": "_auth/(no-layout)/account/delete/confirmation.app.tsx",
      "parent": "/_auth/(no-layout)/account/delete"
    },
    "/_auth/(no-layout)/account/delete/landing/app": {
      "filePath": "_auth/(no-layout)/account/delete/landing.app.tsx",
      "parent": "/_auth/(no-layout)/account/delete"
    },
    "/_auth/_only-header/store/connect-offer/_allowed/checkout": {
      "filePath": "_auth/_only-header/store/connect-offer._allowed.checkout.tsx",
      "parent": "/_auth/_only-header/store/connect-offer/_allowed"
    },
    "/_auth/_only-header/store/connect/_allowed/checkout": {
      "filePath": "_auth/_only-header/store/connect._allowed.checkout.tsx",
      "parent": "/_auth/_only-header/store/connect/_allowed"
    },
    "/_auth/_only-header/store/dm-offer/_allowed/checkout": {
      "filePath": "_auth/_only-header/store/dm-offer._allowed.checkout.tsx",
      "parent": "/_auth/_only-header/store/dm-offer/_allowed"
    },
    "/_auth/_only-header/store/methods-offer/_allowed/checkout": {
      "filePath": "_auth/_only-header/store/methods-offer._allowed.checkout.tsx",
      "parent": "/_auth/_only-header/store/methods-offer/_allowed"
    },
    "/_auth/_only-header/store/connect-offer/_allowed/": {
      "filePath": "_auth/_only-header/store/connect-offer._allowed.index.tsx",
      "parent": "/_auth/_only-header/store/connect-offer/_allowed"
    },
    "/_auth/_only-header/store/connect/_allowed/": {
      "filePath": "_auth/_only-header/store/connect._allowed.index.tsx",
      "parent": "/_auth/_only-header/store/connect/_allowed"
    },
    "/_auth/_only-header/store/dm-offer/_allowed/": {
      "filePath": "_auth/_only-header/store/dm-offer._allowed.index.tsx",
      "parent": "/_auth/_only-header/store/dm-offer/_allowed"
    },
    "/_auth/_only-header/store/methods-offer/_allowed/": {
      "filePath": "_auth/_only-header/store/methods-offer._allowed.index.tsx",
      "parent": "/_auth/_only-header/store/methods-offer/_allowed"
    }
  }
}
ROUTE_MANIFEST_END */
